// ar_SA.js
const ar_SA = {
    "ZiZhangHao":"حساب فرعي",

    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
// مكونات
    "XiaDanTiXing": "تذكير بالطلب",
    "NH_GDDBH_": "مرحبًا، يحتوي هذا الطلب على منتجات بـ\"سعر متوقع\"، يتطلب انتظار تأكيد العرض من العميل قبل الدفع، هل أنت متأكد من أنك تريد تقديم الطلب؟",
    "QueRenXiaDan": "تأكيد الطلب",
    "WoZaiKanKan": "سأرى مرة أخرى",
    "XSQBDZ": "عرض جميع العناوين",
// غرفة الدردشة
    "ZBZCBQFH": "暂不支持表情符号",
    "FaSongLianJie": "إرسال الرابط",
    "YiChangXiaoXi": "رسالة غير طبيعية",
    "QingShuRu": "الرجاء الإدخال",
    "FaSong": "إرسال",
// منتقي التاريخ
    "DQSJXYKSSJ": "الوقت الحالي أقل من وقت البدء",
    "DQSJCGJSSJ": "الوقت الحالي يتجاوز وقت الانتهاء",
    "QuXiao": "إلغاء",
    "NianYueRi": "سنة شهر يوم",
    "ShiFen": "ساعة دقيقة",
    "QueDing": "تأكيد",
    "Nian": "سنة",
    "Yue": "شهر",
    "Ri": "يوم",
    "Shi": "ساعة",
    "Fen": "دقيقة",
// بطاقة قائمة المنتجات
    "Qi": "من",
// ترويج المنتج
    "1GeCuXiao": "1 ترويج",
    "ChaKanZengPin": "عرض المنتجات المجانية",
    "JHDJSHS_1T": "باقي على انتهاء الحملة: {d} يوم {h} ساعة {m} دقيقة {s} ثانية",
    "YHGZ_ZPBKD": "قاعدة الترويج: لا يمكن الحصول على المنتجات المجانية بشكل م叠加",
    "YHGZ_AZZGM": "قاعدة الترويج: استمتع بالعروض حسب كمية الشراء النهائية",
    "GuanBi": "إغلاق",
// مرشح المجموعة
    "QuanBu": "الكل",
    "ZWXGSJ": "لا توجد بيانات ذات صلة",
    "ZuiDiJia": "أقل سعر",
    "ZuiGaoJia": "أعلى سعر",
    "LeiXing": "النوع",
    "PinPai": "العلامة التجارية",
    "BiaoQian": "الوسم",
    "JiaGeQuJian": "نطاق السعر",
    "SPMC_GG_BH_": "اسم المنتج / المواصفات / الرقم التسلسلي / الحرف الأول",
    "ZuHeShaiXuan": "مرشح مُركب",
    "ChongZhi_CanShu": "إعادة تعيين",
// تحميل الصورة
    "ZDKSC1ZTP": "يمكن تحميل ما يصل إلى {num} صورة",
    "ZYXSCTP": "يسمح فقط بتحميل الصور",
    "SCTPDXBYXC": "حجم الصورة المحملة لا يسمح بتحميل ما يزيد عن {size}",
    "QBYCFSCTP_": "الرجاء عدم إعادة تحميل الصور، أو التأكد من أن أسماء الصور فريدة",
    "ShangChuanChengGong": "تم التحميل بنجاح",
    "ZDKSC1Z": "يمكن تحميل ما يصل إلى {num} عنصر",
// لوحة المفاتيح
    "CCSLZDXZ": "تجاوز الحد الأقصى للكمية",
    "QiDingLiang": "حد الطلب الأولي",
    "ShouQi": "اختباء",
    "ShanChu": "حذف",
// متعدد المحเลي
    "FanHui": "العودة",
// عربة الطلب
    "Dai": "بديل",
    "YiQuXiao": "تم الإلغاء",
    "ZengPin": "منتج هدية",
    "1Zhong": "{num} نوع",
    "1Jian": "1 قطعة",
    "HeJi": "المجموع",
    "DaiFu": "لم تتم الدفع بعد",
// ترويج الطلب
    "_DDM1YZ1J_": "【عندما يصل سعر الطلب إلى {targetPrice} يوان، تحصل على {presentNum} قطعة مجاناً】",
    "_DDM1YLJ1Y_": "【عندما يصل سعر الطلب إلى {targetPrice} يوان، تحصل على تخفيض فوري بـ {price} يوان】",
    "_DDM1YLX1Z_": "【عندما يصل سعر الطلب إلى {targetPrice} يوان، تحصل على تخفيض بـ {discount}%】",
    "DingDanCuXiao": "ترويج الطلب",
// إعلان الصفحة
    "DLCKJG": "تسجيل الدخول لعرض السعر",
// عائم الصفحة
    "DianPuZhuYe": "الرئيسية المتجر",
    "GouWuChe": "عربة التسوق",
    "ZaiXianKeFu": "الدعم الفني عبر الإنترنت",
    "GeRenZhongXin": "المركز الشخصي",
    "LianXiDianHua": "رقم الاتصال",
    "FanHuiDingBu": "العودة إلى الأعلى",
// صفحة فارغة
    "ZBDYML": "لا يمكن العثور على الصفحة",
    "KNWZCW_HZY": "قد يكون عنوان URL خاطئًا، أو تم حذف الصفحة",
    "FanHuiShangJi": "العودة إلى الصفحة الرئيسية",
    "FanHuiShouYe": "العودة إلى الصفحة الرئيسية",
// تحرير المنتج
    "SPQDBNWK": "قائمة المنتجات لا يمكن أن تكون فارغة",
    "WoZhiDaoLe": "أنا أعرف",
    "SFQRSCSP": "هل أنت متأكد من حذف المنتج؟",
    "QueRen": "تأكيد",
    "ZYXSRSZBQB": "يسمح فقط بادخال الأرقام ولا يزيد عن 2 أرقام بعد العلامة العشرية",
    "ShangPinDanJia": "سعر الوحدة المنتج",
    "YSPYJ": "سعر المنتج الأصلي",
    "QSRZDJG": "الرجاء إدخال السعر المحدد",
    "ShuLiang": "الكمية",
    "DanWei": "الوحدة",
    "DanJia": "سعر الوحدة",
    "BeiZhu": "ملاحظة",
    "YiChuShangPin": "إزالة المنتج",
    "XiuGai": "تعديل",
// Yunshl
    "TPSLCCYXSZ": "عدد الصور يتجاوز القيمة المسموح بها!",
    "WJBDDY5M_QC": "الملف يجب ألا يزيد حجمه عن 5 ميجابايت، الرجاء اختيار مرة أخرى",
    "TPSCWC": "اكتمل تحميل الصورة",
// مرشح العمل
    "_DGSLM1JZ1J": "【عندما يصل عدد الطلبات إلى {num} قطعة، تحصل على {presentNum} قطعة مجاناً】",
    "_M1JLXMJ1Y_": "【عندما يصل إلى {num} قطعة، تحصل على {price} يوان لكل قطعة】",
    "_DHJJZ1Y_": "【سعر الطلب المنخفض إلى {price} يوان】",
    "_M1JLXMJ1Z_": "【عندما يصل إلى {num} قطعة، تحصل على تخفيض بـ {discount}% لكل قطعة】",
    "_YDHJD1Z_": "【سعر الطلب الأصلي مع تخفيض بـ {discount}%】",
    "YuJi": "متوقع",
    "MMYDDR": "اليوم MM الشهر DD",
    "KaiShiFaHuo": "بدء الشحن",
    "_DGSLM1Z1_": "【عندما يصل عدد الطلبات إلى {num}، تحصل على {presentNum} مجاناً】",
    "_M1LXM1Y_": "【عندما يصل إلى {num}، تحصل على {price} يوان لكل وحدة】",
    "_M1LXM1Z_": "【عندما يصل إلى {num}، تحصل على تخفيض بـ {discount}% لكل وحدة】",
    "DaiQueRen": "لم تتم التأكيد بعد",
    "DaiFaHuo": "لم يتم الشحن بعد",
    "DaiShouHuo": "لم يتم الاستلام بعد",
    "YiWanCheng": "مكتمل",
    "DaiFuKuan": "لم تتم الدفع بعد",
    "YiFuKuan": "تم الدفع",
    "YiZuoFei": "ملغى",
    "DaiShenHe": "لم تتم المراجعة بعد",
    "DaiHeXiao": "لم تتم التنفيذ بعد",
    "YiHeXiao": "تم التنفيذ",
    "XianXiaZhiFu": "الدفع офلاين",
    "ZhiNengDaoZhangShiBie": "التحويل البنكي офلاين (التعرف الذكي على الوصول)",
    "WeiXinZhiFu": "دفع ويچات",
    "KqZhiFu": "دفع كويان (يدعم ويچات/الباي)",
    "ZFBZF": "دفع الباي",
    "YuEZhiFu": "دفع الرصيد",
    "HuoDaoFuKuan": "الدفع عند الاستلام",
    "DaiTuiHuo": "لم يتم الإرجاع بعد",
    "DaiTuiKuan": "لم يتم الاسترجاع بعد",
    "ChuangJianDingDan": "إنشاء طلب",
    "BianJiDingDan": "تعديل الطلب",
    "TiJiaoDingDan": "تقديم الطلب",
    "DingDanShenHe": "مراجعة الطلب",
    "CaiWuShenHe": "مراجعة مالية",
    "BoHui": "رفض",
    "TianJiaShouKuan": "إضافة دفع",
    "ZaiXianZhiFu": "الدفع عبر الإنترنت (يدعم ويچات/الباي/دفع جينغدونغ/ينشانفو)",
    "YinLianZhiFu": "دفع يونيون باي",
    "MercadoPagoZhiFu": "دفع MercadoPago",
    "ShouKuanShenHe": "مراجعة الدفع",
    "ShouKuanZuoFei": "إلغاء الدفع",
    "ChuKu": "الخروج من المخزن",
    "ChuKuShenHe": "مراجعة الخروج من المخزن",
    "FaHuo": "الشحن",
    "TianJiaWuLiu": "إضافة اللوجستية",
    "XiuGaiWuLiu": "تعديل اللوجستية",
    "ChuKuZuoFei": "إلغاء الخروج من المخزن",
    "ShouHuo": "الاستلام",
    "DingDanHeZhun": "الموافقة على الطلب",
    "QuXiaoDingDan": "إلغاء الطلب",
    "CJTHD": "إنشاء طلب إرجاع",
    "DaYin": "طباعة",
    "DaoChu": "تصدير",
    "DingDanWanCheng": "الطلب مكتمل",
    "QiangZhiWanCheng": "الانتهاء القسري",
    "DingDanZuoFei": "إلغاء الطلب",
    "MaiZeng": "شراء وهدية",
    "ZhiJiang": "انخفاض مباشر",
    "DaZhe": "تخفيض",
    "YuShou": "الشراء المسبق",
    "DingDanManZeng": "الطلب مع هدية عند الوصول إلى الحد",
    "DingDanManJian": "الطلب مع تخفيض عند الوصول إلى الحد",
    "DingDanManZhe": "الطلب مع تخفيض النسبة عند الوصول إلى الحد",
    "XinRenQuan": "قسيمة العضو الجديد",
    "ManJianQuan": "قسيمة التخفيض عند الوصول إلى الحد",
    "ShangPinQuan": "قسيمة المنتج",
    "DaiJieSuan": "لم تتم التسوية بعد",
    "YiJieSuan": "تم التسوية",
    "QuanBuShangPin": "جميع المنتجات",
    "TuiJianShangPin": "المنتجات الموصى بها",
    "XinPin": "منتج جديد",
    "ReXiaoShangPin": "المنتجات الشائعة",
    "ChangYongShangPin": "المنتجات الشائعة الاستخدام",
// أدوات العمل
    "DaiShouKuan": "لم يتم الحصول على الدفع بعد",
    "BuFenShouKuan": "حصلت على جزء من الدفع",
    "YiShouKuan": "حصلت على الدفع",
    "BXYFP": "لا تحتاج إلى فاتورة",
    "ZZSPTFP": "فاتورة ضريبة القيمة المضافة العادية",
    "ZZSZYFP": "فاتورة ضريبة القيمة المضافة الخاصة",
    "QiTaFaPiao": "فواتير أخرى",
    "XianXia": "أوفلاين",
    "WeiXin": "ويچات",
    "ZhiFuBao": "الباي",
    "YuCunKuan": "الإيداع المسبق",
    "XianXiaZhuangZhang": "التحويل البنكي офلاين",
    "XianShangZhiFu": "الدفع عبر الإنترنت",
    "YCKZF": "دفع من الإيداع المسبق",
    "DaiTiJiao": "لم تتم التقديم بعد",
    "KuaiDi": "البريد السريع",
    "SongHuoShangMen": "التوصيل إلى المنزل",
    "ShangMenZiQu": "الاستلام من المتجر",
    "WuLiuHuoYun": "نقل البضائع اللوجستي",
    "QiTa": "أخرى",
// أدوات التحقق
    "QSRBXY6WDM": "الرجاء إدخال كلمة مرور لا تقل عن 6 أحرف",
    "QSRBDY20WDM": "الرجاء إدخال كلمة مرور لا تزيد عن 20 حرف",
    "MMGSCW": "تنسيق كلمة المرور غير صحيح",
// أدوات عامة
    "SJCW_QLXKF": "خطأ في البيانات، الرجاء الاتصال بالدعم الفني",
    "ZBZCQD": "暂不支持签到",
    "HuJiao": "اتصل",
    "DLZHBCZ": "حساب تسجيل الدخول غير موجود",
    "QLXGLYKT": "الرجاء الاتصال بالمدير لتفعيل",
    "GQYZHBJY": "حساب الشركة هذا معطل",
    "QLXYSDH": "الرجاء الاتصال بـ Yunshang Order",
    "GQYZHSYQJS": "انتهت فترة تجربة حساب الشركة هذا",
    "GQYZHYGQL": "انتهت صلاحية حساب الشركة هذا",
    "XYXFCNSY": "يتطلب التجديد للاستخدام",
    "GQYBCZCZH": "هذه الشركة لا توجد بهذا الحساب",
    "NDDHZHYBQY": "حساب الطلب الخاص بك قد تم تعطيله بواسطة الشركة 1، لا يمكن تسجيل الدخول. الرجاء الاتصال بالمدير",
    "NYBSQY1DHZ": "أنت لم تعد عميل متعاون مع الشركة 1، لا يمكن تسجيل الدخول. الرجاء الاتصال بالمدير",
    "NDDPYBTY_B": "متجرك تم إيقافه، لا يمكن تسجيل الدخول. الرجاء الاتصال بالمدير",
    "GZHWKTDSZB": "هذا الحساب لم يتم فتح وظيفة النسخة الخاصة بالمراوح. الرجاء الاتصال بالمدير",
    "WXSQYZYGQ": "انتهت صلاحية التحقق من الاعتماد من ويچات",
    "WXSQSB": "فشل الاعتماد من ويچات",
    "WXSQSB_CWX": "فشل الاعتماد من ويچات، رسالة الخطأ",
    "DengLuGuoQi": "انتهت صلاحية تسجيل الدخول",
    "DLGQ_QCXDL": "انتهت صلاحية تسجيل الدخول، الرجاء تسجيل الدخول مرة أخرى",
// ثوابت البيانات
    "ShangJia": "النشر",
    "YiXiaJia": "تم السحب",
    "YiJinYong": "معطل",
    "YiQiYong": "مفعل",
    "YiTingYong": "متوقف",
    "KeHuZhuCe": "تسجيل العميل",
    "XinZengDaoRu": "الاستيراد الجديد",
    "DDDSH": "بانتظار مراجعة الطلب",
    "DCWSH": "بانتظار مراجعة مالية",
    "DaiChuKu": "بانتظار الخروج من المخزن",
    "DCK_BF_": "بانتظار الخروج من المخزن (جزئي)",
    "DFH_BF_": "بانتظار الشحن (جزئي)",
    "DSH_BF_": "بانتظار الاستلام (جزئي)",
    "DSK_BF_": "بانتظار الحصول على الدفع (جزئي)",
    "WTHSQ": "لا يوجد طلب إرجاع",
    "THDSH": "الإرجاع بانتظار المراجعة",
    "THCLZ": "الإرجاع في المعالجة",
    "THYWC": "الإرجاع مكتمل",
    "DYDHD": "طباعة طلب الشراء",
    "DYFHD": "طباعة طلب الشحن",
    "DCDHD": "تصدير طلب الشراء",
    "DCFHDWE_P": "تصدير طلب الشحن كملف Excel/PDF",
    "TuiDanZuoFei": "إلغاء طلب الإرجاع",
    "DTHSH": "بانتظار مراجعة الإرجاع",
    "DaiRuKu": "بانتظار الدخول إلى المخزن",
    "DRK_BF_": "بانتظار الدخول إلى المخزن (جزئي)",
    "DFK_BF_": "بانتظار الدفع (جزئي)",
    "ChuangJianTuiDan": "إنشاء طلب إرجاع",
    "BianJiTuiDan": "تعديل طلب إرجاع",
    "TiJiaoTuiDan": "تقديم طلب إرجاع",
    "TuiHuoShenHe": "مراجعة الإرجاع",
    "RuKu": "الدخول إلى المخزن",
    "RuKuShenHe": "مراجعة الدخول إلى المخزن",
    "RuKuZuoFei": "إلغاء الدخول إلى المخزن",
    "TianJiaFuKuan": "إضافة دفع",
    "FuKuanZuoFei": "إلغاء الدفع",
    "FuKuanShenHe": "مراجعة الدفع",
    "TuiDanWanCheng": "طلب الإرجاع مكتمل",
    "QiTaChuKu": "خروج آخر من المخزن",
    "XiaoShouChuKu": "خروج البيع من المخزن",
    "PanKuiChuKu": "خروج الخسارة من المخزن",
    "DiaoBoChuKu": "خروج التحويل من المخزن",
    "CaiGouTuiHuo": "إرجاع المشتريات",
    "TuiHuoRuKu": "إرجاع الدخول إلى المخزن",
    "CaiGouRuKu": "دخول المشتريات إلى المخزن",
    "QiTaRuKu": "دخول آخر إلى المخزن",
    "PanYingRuKu": "دخول الربح من المخزن",
    "DiaoBoRuKu": "دخول التحويل إلى المخزن",
    "CJCGD": "إنشاء طلب المشتريات",
    "BJCGD": "تعديل طلب المشتريات",
    "TJCGD": "تقديم طلب المشتريات",
    "CGDZF": "إلغاء طلب المشتريات",
    "CGDWC": "طلب المشتريات مكتمل",
    "CGTHZF": "إلغاء إرجاع المشتريات",
    "CGTHWC": "إرجاع المشتريات مكتمل",
    "THDDY": "طباعة طلب الإرجاع",
    "THDDC": "تصدير طلب الإرجاع",
    "CKDDY": "طباعة طلب الخروج من المخزن",
    "CKDDC": "تصدير طلب الخروج من المخزن",
    "GLDZH": "حساب الواجهة الإدارية",
    "DHDZH": "حساب واجهة الطلب",
    "ShenHeTongGuo": "المراجعة مُقبلة",
    "SHBTG": "المراجعة مرفوضة",
    "WuXuFaPiao": "لا تحتاج إلى فاتورة",
    "DaiKeXiaDan": "الطلب نيابة عن العميل",
    "ZiZhuXiaDan": "الطلب الذاتي",
    "PCShangCheng": "متجر ПК",
    "APPShangCheng": "متجر АПП",
    "TVShangCheng": "متجر ТВ",
    "WeiXinShangCheng": "متجر ويچات",
    "ShouJiShangCheng": "متجر الهاتف",
    "ADDXSMLTC": "العمولة حسب ربح البيع من الطلب",
    "ADDXSSRTC": "العمولة حسب إيرادات البيع من الطلب",
    "AKHSSYG": "حسب الموظف التابع للعميل",
    "AnZhiDanRen": "حسب منشئ المستند",
    "ATHJEBLKCT": "خصم مبلغ العمولة بنسبة مبلغ الإرجاع",
    "DDYTHBJXTC": "الطلب مع إرجاع لا يتم تحصيل العمولة",
    "DaiDaKuan": "بانتظار التحويل",
    "WeiKaiShi": "لم يبدأ بعد",
    "JinXingZhong": "جاري التنفيذ",
    "YiGuoQi": "منتهي الصلاحية",
// أدوات Utils.js
    "YouHuo": "متوفر في المخزن",
    "WuHuo": "منتهي من المخزن",
    "Yi": "مليار",
    "QianWan": "عشرة مليون",
    "BaiWan": "مليون",
    "Wan": "ألف",
    "Sheng1Tian": "باقي 1 يوم",
    "Sheng1XiaoShi": "باقي 1 ساعة",
    "Miao": "ثانية",
    "1Miao": "1 ثانية",
    "GangGang": "ألآن",
    "1FenZhongQian": "منذ 1 دقيقة",
    "1XiaoShiQian": "منذ 1 ساعة",
    "1TianQian": "منذ 1 يوم",
    "1GeYueQian": "منذ 1 شهر",
    "1NianQian": "منذ 1 سنة",
    "WeiZhiLeiXing": "نوع غير معروف",
// أدوات WechatUtil
    "YYGBCDSP_K": "هناك منتج جيد، هيا لنرى",
    "ZanWeiSheZhi": "لم يتم الإعداد بعد",
// تطبيق
    "HQWXSQXX": "الحصول على معلومات الاعتماد من ويچات",
// مرن
    "JGJYYDMBQ": "سيتم ضبط نسبة التكبير بناءً على علامات الميتا الموجودة",
// الفهرس
    "NLJZZ": "جاري التحميل",
// روابط
    "ShangPinMingXi": "تفاصيل المنتج",
    "ShangPinLeiBie": "فئة المنتج",
    "QXZFPNR": "الرجاء اختيار محتوى الفاتورة",
    "QXZFPLX": "الرجاء اختيار نوع الفاتورة",
    "QTXFPTT": "الرجاء إدخال عنوان الفاتورة",
    "FaPiaoTaiTou": "عنوان الفاتورة",
    "NSRSBH": "رقم الهوية الضريبية",
    "FaPiaoNeiRong": "محتوى الفاتورة",
    "FaPiaoXinXi": "معلومات الفاتورة",
    "KaiJuFaPiao": "اصدار الفاتورة",
    "FaPiaoLeiXing": "نوع الفاتورة",
    "Han": "يحتوي",
    "WeiHan": "لا يحتوي",
    "Shui": "ضريبة",
    "QSRFPTT": "الرجاء إدخال عنوان الفاتورة",
    "QSRNSRSBH": "الرجاء إدخال رقم الهوية الضريبية",
// عربة الفواتير
    "YiManZu_Man": "تم تحقيق【عندما يصل إلى",
    "ZaiGou": "اشتري المزيد",
    "YMZ_DHJJZ": "تم تحقيق【سعر الطلب المنخفض إلى",
    "JianJiangZhi": "قطعة منخفضة إلى",
    "YMZ_YDHJD": "تم تحقيق【سعر الطلب الأصلي مع",
    "JianMeiJian": "قطعة لكل قطعة",
    "SYTCSLW0_WFJRGWC": "عدد الباقات المتبقية هو 0، لا يمكن إضافتها إلى عربة التسوق",
    "QingXuanXeShangPin": "الرجاء اختيار المنتج!",
    "GSPYXJ": "هذا المنتج قد تم سحبه!",
    "ZJ2TN": "خلال آخر 2 أيام",
    "QDQCXJSP": "هل أنت متأكد من مسح المنتجات المسحوبة؟",
    "QingChuChengGong": "تم المسح بنجاح",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "لا يمكن إضافة المنتجات المجمعة إلى عربة التسوق، الرجاء إلغاء المنتجات المجمعة قبل نقلها إلى عربة التسوق!",
    "SPSLBN": "عدد المنتجات لا يمكن",
    "TaoCanHan": "يحتوي الباقة على",
    "TaoCan": "الباقة",
    "QHDSL": "الرجاء مراجعة الكمية",
    "SPSLBNDY": "عدد المنتجات لا يمكن أن يكون أقل من",
    "XianDingLiang": "حد الطلب",
    "YiRuShouCang": "إضافة إلى المفضلة",
    "QuanXuan": "اختر الكل",
    "JianZeng": "قطعة مجانية",
    "JianLiXiang_Man": "قطعة تحصل على【عندما يصل إلى",
    "Yuan_": "يوان】",
    "Zhe_": "% تخفيض】",
    "KCBZ_WFJRGWC": "المخزن غير كافئة، لا يمكن إضافتها إلى عربة التسوق",
    "XDJEDYDY": "مبلغ الطلب أكبر أو يساوي",
    "WYXJHYSXDSP": "لا توجد منتجات مسحوبة أو منتهية الصلاحية!",
    "DYQDL": "أقل من الحد الأولي للطلب",
    "ZSPG1J": "{count} نوع من المنتجات، إجمالي {number} قطعة",
    "WanCheng": "إتمام",
    "BianJi": "تعديل",
    "You": "يوجد",
    "ZSPBFHYQ_W": "نوع من المنتجات لا يفي بالمتطلبات، لم يتم تحديدها، انقر لعرض العنوان الافتراضي",
    "SPSLBNGY": "عدد المنتجات لا يمكن أن يكون أكبر من",
    "JXDJ_CKXYGBFHYQSP": "الرجاء النقر مستمرًا، لعرض المنتج التالي الذي لا يفي بالمتطلبات",
    "XiaDan": "تقديم الطلب",
    "JianJiang": "قطعة منخفضة",
    "QRYCSP": "هل أنت متأكد من إزالة المنتج؟",
    "QXZXDSP": "الرجاء اختيار المنتجات للتقديم",
    "KCBZ_QCXXZ": "المخزن غير كافئة، الرجاء اختيار مرة أخرى!",
    "KuCun": "المخزن",
    "YCKXD": "يوان لتمكن من تقديم الطلب",
    "QDSCSP": "هل أنت متأكد من إضافة المنتج إلى المفضلة؟",
    "ShouCangChengGong": "تمت الإضافة إلى المفضلة بنجاح",
    "GYXDL": "أعلى من الحد الأولي للطلب",
    "LiSheng": "توفّر على الفور",
    "GWCHSKD_QGYGB": "عربة التسوق لا تزال فارغة، توجّه للتسوق",
    "QuGuangGuang": "توجّه للتسوق",
    "QCXJSP": "مسح المنتجات المسحوبة",
    "ZongE": "إجمالي المبلغ",
    "YouHui": "الخصم",
// قائمة العربة
    "QXZJHRQ": "الرجاء اختيار تاريخ التسليم",
    "FuJiaFeiYong": "الرسوم الإضافية",
    "ZhongShangPin_Gong": "نوع من المنتجات، إجمالي",
    "PeiSongShiJian": "وقت التوصيل",
    "QXZPSSJ": "الرجاء اختيار وقت التوصيل",
    "DingDanJinE": "مبلغ الطلب",
    "SCFJ_ZD4Z": "تحميل المرفقات، ما يصل إلى {num} صورة، لا تتجاوز حجم كل صورة {size}",
    "KeYongShangPin": "المنتجات المتوفرة",
    "ShiYongShuoMing": "التعليمات المستخدمة",
    "YouXiaoQi": "الصلاحية",
    "Man": "عندما يصل إلى",
    "BZZBZCTSFH": "الملاحظات暂不支持特殊符号",
    "QingXuanZe": "الرجاء الاختيار",
    "KaiPiaoXuJia": "يتطلب إضافة الرسوم لاصدار الفاتورة",
    "PeiSongFangShi": "طريقة التوصيل",
    "ShangPinZongJia": "إجمالي سعر المنتجات",
    "YouHuiQuan": "قسيمة الخصم",
    "ZhangKeXan": "عدد القسائم المتوفرة",
    "DDJEWMZ": "مبلغ الطلب لم يصل إلى الحد",
    "WDYHQ": "قسائم الخصم الخاصة بي",
    "KYYHQ": "قسائم الخصم المتوفرة",
    "YuanKeYong": "يوان متاح",
    "ChaKanDingDan": "عرض الطلب",
    "ShangPinHanShui": "المنتج يحتوي على ضريبة",
    "SPWHS": "المنتج لا يحتوي على ضريبة",
    "GeDian": "نقطة",
    "QueRenDingDan": "تأكيد الطلب",
    "XZSHDZ": "إضافة عنوان استلام جديد",
    "ShangPinQingDan": "قائمة المنتجات",
    "WKYYHQ": "لا توجد قسائم خصم متوفرة",
    "HuChi": "تباين",
    "DaiJinQuan": "قسيمة النقدية",
    "YunFei": "تكاليف الشحن",
    "ShuiFei": "تكاليف الضريبة",
    "WKYYY": "سبب عدم القدرة على الاستخدام",
    "YHQYGQ": "قسيمة الخصم منتهية الصلاحية",
    "WDYHQSYSJ": "لم يصل وقت استخدام قسيمة الخصم بعد",
    "ZDSPJEWMZ": "مبلغ المنتج المحدد لم يصل إلى الحد",
    "BKYYHQ": "قسائم الخصم غير المتوفرة",
    "RMBJE": "مبلغ الرمبي",
// طلب التسوق المسبق
    "QXZPSFS": "الرجاء اختيار طريقة التوصيل",
    "1ZSP_G": "1 نوع من المنتجات، إجمالي",
    "YSSP_YJ": "منتج التسوق المسبق، متوقع",
    "JiaoHuoRiQi": "تاريخ التسليم",
    "GMJLY": "اترك رسالة للم판ح",
// مسح للعربة
    "ZhengZaiChuLi...": "جاري المعالجة...",
    "FSCSP": "منتج غير متجر",
    "ZZCLTXM": "جاري معالجة الباركود...",
    "SPTJCG": "تمت إضافة المنتج بنجاح",
    "QSTXM": "الرجاء مسح الباركود",
    "SFSCDQSP": "هل تريد حذف المنتج الحالي؟",
    "BQ_ZBDXGSP": "آسف، لا يمكن العثور على المنتج المتصل",
    "XuanZeDanWei": "اختيار الوحدة",
    "JRGWC": "إضافة إلى عربة التسوق",
    "QXXZDJRSP": "الرجاء اختيار المنتجات التي تريد إضافتها أولاً",
    "ZhengZaiChuLi": "جاري المعالجة",
    "JRGWCCG": "تمت إضافة إلى عربة التسوق بنجاح",
    "ZanWuShangPin": "لا توجد منتجات",
// جني العمولة من المشاركة
    "XTYJBNFZSP": "لقد نسخ النظام رابط المنتج لك!",
    "NKYHDDYDYJ": "يمكنك الحصول على العمولة المقابلة. يمكن عرض العمولة في \"خاص بي",
    "LiChaKan": "عرض",
    "WeiXinHaoYou": "أصدقاء ويچات",
    "ErWeiMa": "رمز الاستجابة السريعة",
    "CASBEWM": "اضغط مطولاً للتعرف على رمز الاستجابة السريعة",
    "FZSB_QCXFZ": "فشل النسخ، الرجاء النسخ مرة أخرى!",
    "TWEWM": "رمز الاستجابة السريعة النص والصورة",
    "BCDXC": "حفظ في الألبوم",
    "CATPBCDXC": "اضغط مطولاً على الصورة لحفظها في الألبوم",
    "FuZhiLianJie": "نسخ الرابط",
    "FXZYJ": "مشاركة لجني العمولة",
    "YJZGKZQYJ": "أعلى مستوى من العمولة المتوقعة",
// مشاركة المنتج
    "FXSPGLSKH": "مشاركة المنتج للعملاء بالتجزئة",
    "FXHJSCNZSD": "بعد المشاركة سيتم إنشاء متجر هاتف محمول خاص بك، يمكنك ضبط أسعار المنتجات في المتجر، إدخال معلومات الاتصال الخاصة بك، وجذب المستهلكين للتسوق.",
    "WSCDQJG_ND": "سعر المتجر المحمول الحالي: سعر طلبك ×",
    "DaiSheZhi": "لم يتم الإعداد بعد",
    "PengYouQuan": "حائط الأصدقاء",
    "GGFXSZ": "تغيير إعدادات المشاركة",
// تسجيل الدخول من ويچات
    "QXSRZH": "الرجاء إدخال الحساب أولاً",
    "MMGSCW_6_20W": "تنسيق كلمة المرور غير صحيح (6-20 حرف أو رقم)",
    "BDYYZH": "ربط حساب موجود",
    "WXKJDL": "تسجيل دخول سريع من ويچات",
    "BangDingZhangHao": "ربط الحساب",
    "YYZH_QDL": "已有 حساب，去登录",
    "ZCXZH": "إنشاء حساب جديد",
    "HuanYingNi": "مرحبًا بك",
    "ZH_SJHM": "حساب/رقم الهاتف",
    "MiMa": "كلمة المرور",
    "QDLHCZ": "الرجاء تسجيل الدخول قبل تنفيذ العملية",
// إضافة إلى العربة
    "KCBZ_BNTJG": "المخزن غير كافئة، لا يمكن إضافة المزيد",
// الدفع المشترك عبر الإنترنت
    "ZhiFuChengGong": "تم الدفع بنجاح!",
    "ZFSB_QCXCS": "فشل الدفع، الرجاء المحاولة مرة أخرى!",
//
    "QXXZGG": "الرجاء اختيار المواصفات أولاً",
    "SXGGX": "المواصفات المختارة تتطلب",
    "GMSLXYQDL_": "كمية الشراء أقل من الحد الأولي للطلب، الرجاء الشراء مرة أخرى!",
    "GMSLDYXDL_": "كمية الشراء أكبر من الحد الأولي للطلب، الرجاء الشراء مرة أخرى!",
    "ShangPinBianHao": "رقم المنتج",
    "QiDing": "الحد الأولي",
    "SXGGDGSLBK": "كمية الطلب للمواصفات المختارة لا يمكن أن تتجاوز",
    "KCBZ_BNTJ": "المخزن غير كافئة، لا يمكن إضافتها",
    "QXXZSP": "الرجاء اختيار المنتج أولاً",
    "SLBNW0": "الكمية لا يمكن أن تكون 0",
    "QXZGG": "الرجاء اختيار المواصفات",
    "LiJiYuDing": "الحجز الفوري",
// شريط التنقل
    "ShouYe": "الرئيسية",
    "ShangPin": "المنتجات",
    "DingDan": "الطلبات",
    "WoDe": "خاص بي",
// الدفع عبر الإنترنت
    "ZhiFuQuXiao": "إلغاء الدفع",
// سجل الحساب
    "ShangPinYongJin": "عمولة المنتج",
    "YaoQingJiangLi": "مكافأة الدعوة",
    "TiXian": "سحب",
    "TiXianBoHui": "رفض السحب",
    "ZhuanWeiYuE": "تحويل إلى الرصيد",
    "Jin7Tian": "آخر 7 أيام",
    "Jin30Tian": "آخر 30 يوم",
    "ShouZhiMingXi": "تفاصيل الدخل والصرف",
    "ZanWuShuJu": "لا توجد بيانات",
// إحصائيات العملاء
    "WoDeKeHu": "عملائي",
    "WoDeYaoQing": "دعواتي",
// الرئيسية التوزيع
    "LeiJiKeHu": "إجمالي العملاء",
    "LeiJiDingDan": "إجمالي الطلبات",
    "YaoQingHaoYou": "دعوة الأصدقاء",
    "LeiJiYaoQing": "إجمالي الدعوات",
    "LJSY_Y_": "إجمالي الدخل (يوان)",
    "BHDJS": "يشمل التسوية المعلقة",
    "J7TSY_Y_": "الدخل خلال آخر 7 أيام (يوان)",
    "J7TXZKH_R_": "العملاء الجدد خلال آخر 7 أيام (عدد الأشخاص)",
    "KTXYJ": "العمولة التي يمكن سحبها",
    "XYJYO": "تحتاج إلى المزيد من الجهد",
    "ChangJianWenTi": "الأسئلة الشائعة",
    "Q_ZMYJX_TG": "س: كيف يمكنني \"الترويج لجني المال\"",
    "A_FXDPND_Z_": "ج: شارك روابط الصفحات التي تحتوي على أيقونة \"جني\" في المتجر، اجذب الأصدقاء لضغط عليها، سيتم تسجيل الأصدقاء (يتم ضبط علاقة العميل على التسجيل即ربط) أو تقديم الطلبات (يتم ضبط علاقة العميل على طلب即ربط) وشراء المنتجات التي تحتوي على أيقونة \"جني\" في المتجر، وسيتم حسابها وفقًا لطريقة حساب معينة كدخل \"الترويج لجني المال\" الخاص بك.",
    "Q_RHJS_TGZ": "س: كيف تُحسب دخل \"الترويج لجني المال\"؟",
    "A_MGD_Z_TBD": "ج: كل منتج يحتوي على أيقونة \"جني\" يحتوي على نسبة عمولة معينة، بدون هذا العلامة يعني أن المنتج لا يشارك في \"الترويج لجني المال\". بعد أن ينجح الأصدقاء في الدفع عبر رابط المشاركة الخاص بك، سيتم حساب العمولة وفقًا لنسبة العمولة لكل منتج في الطلب (العمولة التي لا تشارك في الترويج هي 0)، وأخيرًا تُجمَع لتصبح عائدات العمولة لهذا الطلب. في حساب الدخل سيتم خصم تكاليف الشحن والاسترجاع والتخفيضات等， بناءً على السعر النهائي للبيع.",
    "Q_TGZQ_DSY": "س: متى يتم وصول دخل \"الترويج لجني المال\" إلى الحساب؟",
    "A_HYTGNDFX": "ج: بعد أن ينجح الأصدقاء في الدفع عبر رابط المشاركة الخاص بك، يمكنك رؤية هذا الترويج في طلبات الترويج في مركز البيع، الحالة هي التسوية المعلقة، بعد أن يؤكد العميل على الاستلام ويت завершения giao dịch الطلب والتسوية， سيتم تحويل هذا الدخل تلقائيًا إلى حسابك الشخصي، ويمكن سحبه في أي وقت.",
    "Q_LJKH_LJY": "س: قائمة العملاء المتراكمة وقائمة الدعوات المتراكمة لا تحتوي على صورة أو اسم؟",
    "A_WXYQZYGZ": "ج: يتطلب ويچات فقط متابعة حساب الخدمة المعتمد للحصول على الصورة والاسم، العملاء المتجر هو حساب الخدمة المعتمد متابعون للحساب الرسمي للمتجر، لا حساب الخدمة المعتمد متابعون للحساب الرسمي \"Yunshang Order\" ثم النقر على أي صفحة تفاصيل المنتج في المتجر يمكن للحصول على الصورة والاسم.",
    "Q_WSMWASSG": "س: لماذا لم أحصل على عائدات الترويج بالرغم من المشاركة وفقًا للقواعد أعلاه؟",
    "A_1_HYKNBW": "ج: 1. قد لا يكون الأصدقاء قد أنشأوا علاقة عميل معك (لقد النقر الأصدقاء على روابط البائعين الآخرين للتسجيل أو تقديم الطلبات) 2. إذا كان الأصدقاء يفتحون رابط المشاركة الخاص بك خارج بيئة ويچات (مثل متصفح الهاتف الافتراضي)، إذا لم يفتح المتصفح ملفات تعريف الارتباط، لن يتم تسجيل علاقة العميل، أي لن يتم تسجيل طلبات الترويج 3. إذا لم يتم تسجيل طلبات الترويج على الرغم من عدم وجود مشاكل أعلاه، الرجاء الاتصال بالموظفين",
//
    "XiaoShouZhongXin": "مركز البيع",
// الترويج للمنتجات
    "SPMC_GG_BH": "اسم المنتج / المواصفات / الرقم التسلسلي",
    "YuJiZhuan": "المتوقع لجني",
// الرئيسية الدعوة
    "YaoQingKa": "بطاقة الدعوة",
    "YNYQJR_TGY": "دعوك للانضمام معنا، الترويج لجني المكافآت",
    "DJBCDXC": "انقر لحفظ في الألبوم",
    "JYQKFSGHY_": "أرسل بطاقة الدعوة إلى الأصدقاء، الترويج للمتجر للحصول على مكافأة",
// الرئيسية الانضمام
    "HuanYingJiaRu": "مرحبًا بك في الانضمام",
    "YQNCW": "دعوك أنت成为",
    "LiJiJiaRu": "الانضمام الفوري",
// إحصائيات الطلب
    "YuJiYongJin": "العمولة المتوقعة",
    "YongJin": "العمولة",
    "YuJiJiangLi": "المكافأة المتوقعة",
    "JiangLi": "المكافأة",
    "SPTGDD": "طلبات الترويج للمنتجات",
    "YQJLDD": "طلبات مكافأة الدعوة",
// إحصائيات الأداء
    "YeJiTongJi": "إحصائيات الأداء",
    "LJKH_R_": "إجمالي العملاء (عدد الأشخاص)",
    "SPYJ_Y_": "عمولة المنتج (يوان)",
    "HanDaiJieSuan": "يشمل التسوية المعلقة",
    "XGMCJS": "تفسير المصطلحات ذات الصلة",
    "KeHu": "العميل",
    "HFXYBDLKHG": "المشتري أو الموزع الذي ربط علاقة عميل مع الموزع",
    "YaoQing": "الدعوة",
    "FXYCGYQDXJ": "الموزع الفرعي الذي تم دعوته بنجاح بواسطة الموزع",
    "FXYTJKHGMH": "العمولة التي يمكن للموزع الحصول عليها بعد توصية العميل بالشراء",
    "XJFXYTGSPH": "المكافأة التي يحصل عليها الأعلى بعد الترويج للموزع الفرعي للمنتجات",
// الترويج بالملصق
    "NiCheng": "اللقب",
    "HaiBaoTuiGuang": "الترويج بالملصق",
    "JHBFSGHY_T": "أرسل الملصق إلى الأصدقاء، الترويج للمتجر للحصول على مكافأة",
// مركز التسوية
    "JieSuanZhongXin": "مركز التسوية",
    "KTXJE": "مبلغ السحب المتاح",
    "TiXianJiLu": "سجل السحب",
// حساب السحب
    "KHRXMBNWK": "اسم صاحب الحساب لا يمكن أن يكون فارغًا!",
    "KHHBNWK": "البنك المُفتوح لا يمكن أن يكون فارغًا!",
    "YHKHBNWK": "رقم البطاقة البنكية لا يمكن أن يكون فارغًا!",
    "SFZTPBNWK": "صورة الهوية لا يمكن أن تكون فارغة!",
    "YHKTPBNWK": "صورة البطاقة البنكية لا يمكن أن تكون فارغة!",
    "BaoCunChengGong": "تم الحفظ بنجاح!",
    "SCSFZ": "تحميل الهوية",
    "SCYHK": "تحميل البطاقة البنكية",
    "BaoCun": "حفظ",
    "TiXianZhangHu": "حساب السحب",
    "TS_QTXZSXX": "ملاحظة: الرجاء إدخال المعلومات الحقيقية، يمكن السحب فقط بعد الموافقة على المراجعة",
    "KHRXM": "اسم صاحب الحساب",
    "KaiHuHang": "البنك المُفتوح",
    "YinhangKaHao": "رقم البطاقة البنكية",
    "QSRZSXM": "الرجاء إدخال الاسم الحقيقي",
    "QSRKHHMC": "الرجاء إدخال اسم البنك المُفتوح",
    "QSRYHKH": "الرجاء إدخال رقم البطاقة البنكية",
// سحب الوديعة
    "QXSZTXZH": "الرجاء ضبط حساب السحب أولاً",
    "QuSheZhi": "الذهاب إلى الإعداد",
    "JEXY10Y_BKT": "المبلغ أقل من 10 يوان، لا يمكن السحب!",
    "JECGKTXJE": "المبلغ يتجاوز مبلغ السحب المتاح!",
    "CGDRKTXSX_": "تجاوز الحد الأقصى للسحب اليومي، الحد الأقصى للسحب اليومي هو 20000 يوان!",
    "QueDingJiang": "هل أنت متأكد من تحويل",
    "ZhuanDaoYuE": "إلى الرصيد؟",
    "1_JEDY10YSB": "1. لا يمكن السحب عندما يكون المبلغ أقل من 10 يوان؛",
    "2_BCTXDZSJ": "2. وقت وصول هذا السحب هو خلال 5 أيام عمل من وقت تقديم طلب السحب بنجاح، الحد الأقصى للسحب اليومي هو 20000 يوان؛",
    "3_GBSRWHSS": "3. هذا الدخل هو دخل يحتوي على ضريبة، الرجاء التقديم самолично ودفع ضريبة الدخل الشخصي لدى الجهات الضريبية ذات الصلة!",
    "4_ZDYEKYYS": "4. يمكن استخدام الرصيد المحول للتسوق في المتجر؛",
    "TXSQCG_QDD": "تم تقديم طلب السحب بنجاح، الرجاء الانتظار للموافقة",
    "JEDYKTXJE_": "المبلغ أكبر من مبلغ السحب المتاح، لا يمكن تحويله إلى الرصيد!",
    "ZZYECG_QDG": "تم تحويل الرصيد بنجاح، الرجاء الذهاب إلى المركز الشخصي للعرض!",
    "BenCiTiXian": "هذا السحب",
    "ZhuangDaoYuE": "تحويل إلى الرصيد",
    "TiXianDao": "سحب إلى",
    "JEW0BKZZYE": "المبلغ 0 لا يمكن تحويله إلى الرصيد!",
    "DRTXSX2WY": "الحد الأقصى للسحب اليومي 20000 يوان",
    "QuanBuTiXian": "سحب الكل",
    "QueRenTiXian": "تأكيد السحب",
// علامة مرشح المنتجات
    "ZuiChangGouMai": "الأكثر مبيعاً",
    "MoRenPaiXu": "الترتيب الافتراضي",
    "ZongHe": "المتكامل",
    "FenLei": "التصنيف",
    "XiaoLiangYouXian": "الأولوية للمبيعات",
    "XiaoLiang": "المبيعات",
    "JiaGe": "السعر",
    "ShaiXuan": "مرشح",
    "ZuiJinGouMai": "الأكثر مبيعاً مؤخرًا",
    "CuXiaoYouXian": "الأولوية للترويج",
    "QuanBuFenLei": "جميع التصنيفات",
    "ZhiKanCuXiao": "عرض الترويج فقط",
    "XuanZeFenLei": "اختيار التصنيف",
    "QXZFL": "الرجاء اختيار التصنيف",
// قائمة المنتجات الافتراضية
    "ZWXGSP": "لا توجد منتجات ذات صلة",
// قائمة العلامات التجارية للمنتجات
    "PinPaiHui": "汇 العلامات التجارية",
// مرشح التصنيف للمنتجات
    "TuiJianFenLei": "التصنيفات الموصى بها",
    "ShangPinFenLei": "تصنيف المنتجات",
    "GengDuo": "المزيد",
// تفاصيل المنتج
    "DLZHBSDQQY": "حساب تسجيل الدخول ليس حساب العميل الخاص بالشركة الحالية",
    "GXNHQ": "تهانينا لك على الحصول على",
    "SZWSCJGH_C": "يمكن المشاركة فقط بعد ضبط سعر المتجر المحمول",
    "JHDJSHS_": "باقي على انتهاء الحملة",
    "DLHKFX": "يمكن المشاركة بعد تسجيل الدخول",
    "ZZHQXX_QSH": "جاري الحصول على المعلومات، الرجاء المحاولة لاحقًا",
    "Zhang": "张",
    "Tian": "يوم",
    "QXZGGZQPD": "الرجاء اختيار المواصفات قبل الذهاب إلى ضبط الأضواء!",
    "Yuan": "يوان",
    "XS_F_M": "ساعة/دقيقة/ثانية",
// النقاط
    "WoDeJiFen": "نقاطي",
    "DaBaiLe": "هزيم",
    "JiFen": "نقاط",
    "DeHuiYuan": "عضو",
    "ZhuanJiFen": "جني نقاط",
    "JiFenMingXi": "تفاصيل النقاط",
    "HuanLiPin": "تبادل الهدايا",
    "CKGDHL": "عرض المزيد من الهدايا",
    "ChaDingDan": "عرض الطلب",
// تحويل النقاط
    "DHSLBNCG": "عدد التبديلات لا يمكن أن يتجاوز",
    "DuiHuanShuLiang": "عدد التبديلات",
    "SuoXuJiFen": "النقاط المطلوبة",
// تفاصيل النقاط
    "LiPinXiangQing": "تفاصيل الهدية",
    "WoYaoDuiHuan": "أريد التبديل",
    "ShengYu": "المتبقي",
    "TuWenXiangQing": "تفاصيل النص والصورة",
    "YiDuiWan": "تم التبديل بالكامل",
// مرشح النقاط
    "FenLeiShaiXuan": "مرشح التصنيف",
    "JiFenShaiXuan": "مرشح النقاط",
// تدفق النقاط
    "JiFenShouRu": "إيرادات النقاط",
    "JiFenZhiChu": "مصاريف النقاط",
// لوجستية النقاط
    "DingDanGenZong": "تتبع الطلب",
    "WuLiuGongSi": "شركة اللوجستية",
    "WuLiuDanHao": "رقم الشحنة",
// طلب النقاط
    "DingDanLieBiao": "قائمة الطلبات",
    "YiFaHuo": "تم الشحن",
    "JiFenDingDan": "طلب النقاط",
    "ChaKanWuLiu": "عرض اللوجستية",
// إنشاء طلب النقاط
    "LPSLBZ_QCX": "عدد الهدايا غير كافٍ، الرجاء الدفع مرة أخرى",
    "JiFenBuZu": "النقاط غير كافية",
    "ZhiFuXinXi": "معلومات الدفع",
    "JiXuGuangGuang": "الاستمرار في التسوق",
    "QTXSHXX": "الرجاء إدخال معلومات الاستلام",
    "DuiHuanChengGong": "تم التبديل بنجاح",
    "LPDHQR": "تأكيد تبادل الهدية",
    "SCCKJ": "سعر参考市场",
    "LiJiZhiFu": "الدفع الفوري",
// تفاصيل طلب النقاط
    "DingDanXiangQing": "تفاصيل الطلب",
    "DingDanZhuangTai": "حالة الطلب",
    "DingDanBianHao": "رقم الطلب",
    "DuiHuanShiJian": "وقت التبديل",
    "ShouHuoXinXi": "معلومات الاستلام",
    "HuaFeiJiFen": "النقاط المستخدمة",
// قواعد النقاط
    "QDZJF": "التوقيت لجني نقاط",
    "XDZJF": "تقديم الطلب لجني نقاط",
    "DDWCHKHDYD": "يمكن الحصول على نقاط بعد اكتمال الطلب مع مبلغ الطلب*",
    "1_MRQD_JL": "1. التوقيت اليومي، المكافأة",
    "2_LXQD3T_EW": "2. التوقيت لمدة 3 أيام متتالية، مكافأة إضافية",
    "3_LXQD7T_EW": "3. التوقيت لمدة 7 أيام متتالية، مكافأة إضافية",
    "BeiDeJiFen": "نقاط مضاعفة",
    "DLZJF": "تسجيل الدخول لجني نقاط",
    "MeiRiDengLu": "تسجيل الدخول اليومي",
    "SC_JL": "المتجر، المكافأة",
// تفاصيل قواعد النقاط
    "GuiZe": "القواعد",
// توقيت النقاط
    "QianDaoYouLi": "التوقيت مع مكافأة",
    "QianDaoGuiZe": "قواعد التوقيت",
    "YLXQD": "تم التوقيت لمدة",
    "QDCG_NYJLX": "تم التوقيت بنجاح، لقد قمت بالتوقيت لمدة",
    "QDCG_BCHD": "تم التوقيت بنجاح، الحصول على",
    "QSRBZ": "الرجاء إدخال ملاحظة",
    "DingDanZengPin": "منتج هدية الطلب",
    "GuiGeBianHao": "رقم المواصف",
    "GuiGe": "المواصفات",
// الدفع المشترك
    "CDDWXFK": "هذا الطلب لا يتطلب الدفع",
    "YHYEBZ": "رصيد المستخدم غير كافٍ!",
    "ZFJEBNW0": "مبلغ الدفع لا يمكن أن يكون 0!",
    "ZFJEBNDYDD": "مبلغ الدفع لا يمكن أن يكون أكبر من مبلغ الدفع المستحق للطلب",
    "DFKJE": "مبلغ الدفع المستحق",
    "FuKuanFangShi": "طريقة الدفع",
    "FuJian": "مرفق",
    "ZHYFZ": "تم نسخ الحساب",
    "GHSKZH": "تغيير حساب القبض",
    "SYXXZFQSCF": "الرجاء تحميل لقطة شاشة الدفع كملف مرفق عند استخدام الدفع офلاين، لتمكن قسم المحاسبة من التأكد من المبلغ!",
    "XXZF_BXXZS": "الدفع офلاين، يجب اختيار حساب القبض",
    "DingDanZhiFu": "دفع الطلب",
    "ZFFS_HDFK": "طريقة الدفع: الدفع عند الاستلام",
    "BCFKJE": "مبلغ الدفع هذا",
    "YuE": "الرصيد",
    "FuZhiZhangHao": "نسخ الحساب",
    "WSZXCXZFPZ": "لم يتم ضبط تكوين الدفع من التطبيق الصغير",
    "XCXZFZHJY": "حساب الدفع من التطبيق الصغير معطل",
    "SRZFJE": "إدخال مبلغ الدفع",
    "FuKuanZhangHu": "حساب الدفع",
    "QueRenZhiFu": "تأكيد الدفع",
    "ShaoHouZhiFu": "الدفع لاحقًا",
// الطلب
    "FKJLYTJ_DD": "تمت إضافة سجل الدفع، في انتظار مراجعة قسم المحاسبة",
    "JiXuGuang": "الاستمرار في التسوق",
    "BenCiFuKuan": "هذا الدفع",
    "FuKuanChengGong": "تم الدفع بنجاح",
    "ZhiFuFangShi": "طريقة الدفع",
    "ZhiFuDingDan": "طلب الدفع",
// الدفع الجماعي
    "QXXZSXZFDD": "الرجاء اختيار الطلبات التي تريد دفعها أولاً",
    "PiLiangFuKuan": "الدفع الجماعي",
    "FuKuan": "دفع",
    "'QuFuKuan'": "الذهاب إلى الدفع",
// نتيجة إنشاء الطلب
    "YingFuJinE": "مبلغ الدفع المستحق",
    "XiaDanShiJian": "وقت تقديم الطلب",
// التسليم الطلب
    "SFQRSH": "هل أنت متأكد من الاستلام؟",
    "DDQRSH_": "هل تؤكد استلام الطلب؟",
    "DFHSP": "المنتجات التي تنتظر الشحن",
    "ShangPinShuLiang": "عدد المنتجات",
    "ChuKuShiJian": "وقت الخروج من المخزن",
    "FaHuoShiJian": "وقت الشحن",
    "WuLiuBeiZhu": "ملاحظات اللوجستية",
    "QueRenShouHuo": "تأكيد الاستلام",
    "RYFK_QJSYG": "إذا تم الدفع بالفعل، الرجاء الاتصال بالمدير في الوقت المناسب",
    "QSRQXYY": "الرجاء إدخال سبب الإلغاء",
    "H_DDJZDGB_QJKF": "بعد ذلك، سيتم إغلاق الطلب تلقائيًا، الرجاء الدفع في أسرع وقت ممكن",
    "TuiHuoQingKuang": "حالة الإرجاع",
    "DingDanZongE": "إجمالي مبلغ الطلب",
    "DingDanBeiZhu": "ملاحظات الطلب",
    "FaHuoQingKuang": "حالة الشحن",
    "DingDanFuJian": "مرفقات الطلب",
    "ShenQingTuiHuo": "طلب الإرجاع",
    "G1TDSHJL_QRS": "إجمالي {num} سجل في انتظار الاستلام، هل تؤكد الاستلام؟",
    "DaiXiaDan": "الطلب نيابة عن العميل",
    "DingDanHao": "رقم الطلب",
    "XiaDanFangShi": "طريقة تقديم الطلب",
    "TuiHuoDan": "طلب الإرجاع",
    "ShangPinZongE": "إجمالي سعر المنتجات",
    "YunFei_ZongZhong": "تكاليف الشحن (الوزن الإجمالي",
    "SF_SPWS": "الضريبة (المنتج بدون ضريبة",
    "TePiJia": "سعر خاص",
    "FuKuanQingKuang": "حالة الدفع",
    "TiaoJiLu": "سجل",
    "ZaiLaiYiDan": "طلب آخر",
    "QDSCGDD_": "هل أنت متأكد من حذف هذا الطلب؟",
    "YiQueRen": "تم التأكيد",
    "YiShouHuo": "تم الاستلام",
    "DaiFuJinE": "مبلغ الدفع المستحق",
    "YiFuJinE": "مبلغ الدفع المُựcع",
    "ZanWuJiLu": "لا توجد سجلات",
    "SPMC_DDH": "اسم المنتج / رقم الطلب",
    "FuKuanZhuangTai": "حالة الدفع",
    "FaHuoZhuangTai": "حالة الشحن",
    "QiShiShiJian": "وقت البدء",
    "ZhongZhiShiJian": "وقت الانتهاء",
// قائمة الطلبات
    "CaoZuoChengGong": "تمت العملية بنجاح",
    "ZBKGM": "暂不可购买",
    "DQDDSPYXJ": "منتج الطلب الحالي قد تم سحبه",
    "DQDDBFSPYXJ": "بعض منتجات الطلب الحالي قد تم سحبها",
    "JTJSJSP": "إضافة فقط المنتجات المنشورة",
    "DingHuoDan": "طلب الشراء",
// سجل الطلب
    "DingDanRiZhi": "سجل الطلب",
// لوجستية الطلب
    "FuZhiChengGong": "تم النسخ بنجاح",
    "FuZhiShiBai": "فشل النسخ",
    "FuZhi": "نسخ",
    "BoDa": "اتصل",
    "WCWLDHXX": "لا توجد معلومات لهذا رقم الشحنة",
// دفع الطلب
    "ZFCS_QCXXD": "انتهت مهلة الدفع، الرجاء تقديم الطلب مرة أخرى",
    "YQYYCKZF": "تم تفعيل الدفع من الوديعة",
    "BNDYDFKJE": "لا يمكن أن يكون أكبر من مبلغ الدفع المستحق",
        "ZFJEBNWK": "مبلغ الدفع لا يمكن أن يكون فارغًا",
    "QXAPFK_FKH": "الرجاء تنظيم الدفع أولاً، بعد الدفع قم بتحميل لقطة شاشة معلومات الدفع، لتمكن قسم المحاسبة من التأكد من المبلغ",
    "DDTJCG_QJS": "تم تقديم الطلب بنجاح، الرجاء الدفع في الوقت المناسب",
    "QXZFKFS": "الرجاء اختيار طريقة الدفع",
    "SYYEZFH_HX": "بعد الدفع من الرصيد، لا يزال يحتاج إلى الدفع",
//
    "FuKuanJiLu": "سجل الدفع",
    "ZWFKJL": "لا توجد سجلات دفع",
    "FuKuanXiangQing": "تفاصيل الدفع",
    "FuKuanJinE": "مبلغ الدفع",
    "ZhiDan": "إنشاء المستند",
    "ShenHe": "المراجعة",
    "ZuoFei": "ملغى",
    "ZuoFeiYuanYin": "سبب الإلغاء",
    "GLDHD": "طلب الشراء المرتبط",
    "HeXiaoJinE": "مبلغ التنفيذ",
    "HeXiaoZhuangTai": "حالة التنفيذ",
    "DanJuZhuangTai": "حالة المستند",
    "KeHuMingCheng": "اسم العميل",
    "ZhangDanHao": "رقم الفاتورة",
    "ShouKuanZhangHao": "حساب القبض",
    "ShouKuanShiJian": "وقت القبض",
    "FuKuanPingZheng": "مدى الدفع",
    "GeFuJian": "مرفق",
// إحصائيات الطلب
    "DingDanTongJi": "إحصائيات الطلب",
    "DingHuo": "الطلب",
    "Bi": "عدد",
// تفاصيل إحصائيات الطلب
    "DDTJMX": "تفاصيل إحصائيات الطلب",
    "AGGTJ": "الإحصاء حسب المواصفات",
    "AFLTJ": "الإحصاء حسب التصنيف",
    "DDJE_Y": "مبلغ الطلب/يوان",
    "DHSP_Z": "منتجات الطلب/نوع",
    "DingHuoDan_Bi": "طلبات الشراء/عدد",
    "DingHuoShangPin": "منتجات الطلب",
    "JinE": "المبلغ",
// قائمة الإرجاع
    "TuiHuo": "الإرجاع",
// طلب الإرجاع
    "THDHWBC_QD": "لم يتم حفظ طلب الإرجاع بعد، هل أنت متأكد من المغادرة؟",
    "QSRSQTHJE": "الرجاء إدخال مبلغ طلب الإرجاع",
    "QSRTHJE": "الرجاء إدخال مبلغ الإرجاع",
    "QSRBZXX": "الرجاء إدخال معلومات الملاحظة",
    "YingTuiJinE": "المبلغ المستحق للإرجاع",
    "TJTHSQ": "تقديم طلب الإرجاع",
    "QXXZDHQD": "الرجاء اختيار قائمة الطلب أولاً",
    "DingHuoQingDan": "قائمة الطلب",
    "SQTHJE": "مبلغ طلب الإرجاع",
    "DJXZSP": "انقر لاختيار المنتجات",
    "TuiHuoJinE": "مبلغ الإرجاع",
// تفاصيل الإرجاع
    "THDDXQ": "تفاصيل طلب الإرجاع",
    "YiTuiHuo": "تم الإرجاع",
    "YiTuiKuan": "تم الاسترجاع",
    "THDZT": "حالة طلب الإرجاع",
    "TuiHuoDanHao": "رقم طلب الإرجاع",
    "TuiHuoShiJian": "وقت الإرجاع",
    "TuiHuoCangKu": "مخزن الإرجاع",
    "THLXR": "جهة الاتصال للإرجاع",
    "TuiHuoQingDan": "قائمة الإرجاع",
    "TuiKuanZongE": "إجمالي مبلغ الاسترجاع",
    "TuiKuanQingKuang": "حالة الاسترجاع",
    "DaiTuiJinE": "مبلغ الاسترجاع المستحق",
    "YiTuiJinE": "مبلغ الاسترجاع المُựcع",
// منتج الإرجاع
    "SPMC_BH_GG": "اسم المنتج / الرقم التسلسلي / رقم المواصف / الباركود",
    "GZD1TJG": "تم العثور على 1 نتيجة",
    "JiaRuQingDan": "إضافة إلى القائمة",
// نتيجة الإرجاع
    "ShenQingChengGong": "تم تقديم الطلب بنجاح",
    "THDTJCG": "تم تقديم طلب الإرجاع بنجاح",
    "ChaKanXiangQing": "عرض التفاصيل",
// طابق حزمة المنتجات
    "HDWKS_WDZL": "الحدث لم يبدأ بعد، أعود لاحقًا",
    "HDYJS_XCZD": "انتهى الحدث،来得早点下次",
    "ZWSZBT": "لم يتم ضبط العنوان بعد",
    "ChaKanGengDuo": "عرض المزيد",
// طابق الترويج للمنتجات
    "HCDZSJC": "فارق زمني بسبب التخزين المؤقت",
    "DLCKCXJ": "تسجيل الدخول لعرض سعر الترويج",
    "ZWSZCX": "لم يتم ضبط الترويج بعد",
    "JuKaiShi": "منذ البدء",
    "Song": "إرسال",
    "JuJieShu": "منذ الانتهاء",
    "YiJieShu": "انتهى",
// طابق البحث
    "XiaoXi": "الرسائل",
    "SaoMaXiaDan": "مسح ل تقديم الطلب",
// تخصيص الصفحة الرئيسية
    "WZLCSJ": "بيانات الطابق المجهولة",
// خطأ التحويل
    "QXZYSDHAPP": "الرجاء تنزيل تطبيق Yunshang Order",
    "QMTYQYGLD": "تجربة كاملة لواجهة إدارة الشركة",
    "XZYSDHAPP": "تنزيل تطبيق Yunshang Order",
    "HQGLDWZTY": "الحصول على تجربة كاملة لواجهة الإدارة",
    "JXTYDHD": "الاستمرار في تجربة واجهة الطلب",
// تفاصيل الإعلان
    "GongGaoXiangQing": "تفاصيل الإعلان",
    "GongGaoFuJian": "مرفقات الإعلان",
// خطأ المتجر
    "NFWDYMBCZO": "الصفحة التي تزورها غير موجودة~",
    "KeNengYuanYin": "أسباب محتملة",
    "1_ZDZLSRCWD": "1. أدخل عنوانًا خاطئًا في شريط العنوان;",
    "2_DJLGQLJ": "2. النقر على رابط منتهي الصلاحية.",
// الفهرس المتجر
    "GuanLiDuan": "الواجهة الإدارية",
    "ZhuCe": "التسجيل",
    "HYNTYYSDH": "مرحبًا بك في تجربة Yunshang Order",
    "TYZHSJHDQG": "سيتم تحديث بيانات حساب التجربة بانتظام، الرجاء عدم إدخال معلومات مهمة",
    "TYZHZDNRSJ": "جميع البيانات والمحتويات في حساب التجربة مزيفة، الرجاء عدم إدخال معلومات مهمة",
    "ZHZCCG": "تم التسجيل بنجاح",
    "DengLuZhangHao": "حساب تسجيل الدخول",
    "CSMMW": "كلمة المرور الافتراضية هي",
    "GNFYHQL": "لقد أرسلنا لك قسائم خصم",
    "Man1YuanKeYong": "يمكن استخدامه عندما يصل إلى {num} يوان",
    "LQH1TNKY": "يمكن استخدامه خلال {day} أيام بعد الحصول على القسيمة",
    "YiJianLingQu": "الاستلام بضغط واحد",
    "GXNHD1ZYHQ": "تهانينا لك على الحصول على 1 قسيمة خصم",
    "Gong1Yuan": "إجمالي 1 يوان",
    "LiJiShiYong": "الاستخدام الفوري",
// تسجيل دخول المتجر
    "NHWDL": "أنت لم تسجل الدخول بعد",
// إعلانات المتجر
    "ShangChengGongGao": "إعلانات المتجر",
    "ZanWuGongGao": "لا توجد إعلانات",
    "1GeFuJian": "{num} مرفق",
// تفاصيل الوديعة
    "KouKuan": "الخصم",
    "ChongZhi_Kuan": "الإيداع",
    "KouKuanZuoFei": "الخصم ملغى",
    "ChongZhiZuoFei": "الإيداع ملغى",
    "ZhangHuMingXi": "تفاصيل الحساب",
    "ZhangHuYuE": "رصيد الحساب",
    "LiJiChongZhi": "الإيداع الفوري",
// شحن الوديعة
    "CZJEBNXY1Y": "مبلغ الإيداع لا يمكن أن يكون أقل من 1 يوان",
    "QSRZQDSZ": "الرجاء إدخال قيمة صحيحة",
    "ZDYJE": "مبلغ مخصص",
    "ZWKTXSCZGN": "لم يتم فتح وظيفة الشحن عبر الإنترنت بعد",
    "ShiFuJinE": "مبلغ الدفع الفعلي",
    "ZhangHuChongZhi": "شحن الحساب",
    "QXZCZJE": "الرجاء اختيار مبلغ الشحن",
    "QSRCZJE": "الرجاء إدخال مبلغ الشحن",
    "QLXNDZSYWY": "الرجاء الاتصال بالبائع الخاص بك لإيداع الأموال",
    "ShouJia": "سعر البيع",
    "YiShouQing": "مستنفذ",
    "ChongZhiJinE": "مبلغ الشحن",
    "QueRenFuKuan": "تأكيد الدفع",
// نتيجة شحن الوديعة
    "QSDDID": "نقص معرف الطلب",
    "ChongZhiChengGong": "تم الشحن بنجاح",
    "ChongZhiShiBai": "فشل الشحن",
    "CLZ_QSH...": "جاري المعالجة، الرجاء الانتظار...",
    "ChongZhiFangShi": "طريقة الشحن",
    "ChongZhiShiJian": "وقت الشحن",
    "JYLSH": "رقم سجل المعاملة",
    "FanHuiShangCheng": "العودة إلى المتجر",
// الشحن عبر الإنترنت
    "ZFSB_QCS": "فشل الدفع، الرجاء المحاولة مرة أخرى",
    "ZFYQX": "تم إلغاء الدفع",
    "ZFYC_QCS": "عطلة في الدفع، الرجاء المحاولة مرة أخرى",
// المستخدم
    "LingQuanZhongXin": "مركز الحصول على القسائم",
    "WeiShiYong": "لم يتم الاستخدام",
    "YiShiYong": "تم الاستخدام",
    "ZWYHQ": "لا توجد قسائم خصم",
// قائمة الاحتفاظ
    "YiGouMai": "تم الشراء",
    "ChangYongQingDan": "القائمة الشائعة الاستخدام",
    "WoDeShouCang": "مفضلاتي",
    "QuGouWuChe": "الذهاب إلى عربة التسوق",
    "GeShangPin": "منتج",
// تسجيل الدخول
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "الرجاء إدخال الحساب!",
    "QSRMM": "الرجاء إدخال كلمة المرور!",
    "QSRDLZH": "الرجاء إدخال حساب تسجيل الدخول",
    "JiZhuMiMa": "تذكر كلمة المرور",
    "WangJiMiMa": "نسيت كلمة المرور؟",
    "DengLu": "تسجيل الدخول",
    "DLZHBCZ_QL": "حساب تسجيل الدخول غير موجود، الرجاء الاتصال بالمدير لتفعيله",
    "GQYZHSBJY_": "حساب الشركة هذا معطل، الرجاء الاتصال بـ Yunshang Order",
    "GQYZHSYQJS_": "انتهت فترة تجربة حساب الشركة هذا، الرجاء الاتصال بـ Yunshang Order",
    "GQYZHYGQL_": "انتهت صلاحية حساب الشركة هذا، يتطلب التجديد للاستخدام، الرجاء الاتصال بـ Yunshang Order",
    "LiJiTiYan": "التجربة الفورية",
// مجموعتي
    "YiChuChengGong": "تمت الإزالة بنجاح",
    "QueHuo": "منتهي من المخزن",
    "YCSCJ": "إزالة من المفضلة",
// رسائل الطلب
    "SheZhiChengGong": "تم الإعداد بنجاح",
    "ZWWDXX": "لا توجد رسائل غير مقروئة",
    "QuanBuYiDu": "جميعها مقروئة",
    "DingDanXiaoXi": "رسائل الطلب",
    "YiQiang": "تم الالتفاف",
    "LiJiLingQu": "الاستلام الفوري",
    "LingQuanHou": "بعد الحصول على القسيمة",
    "TianNeiKeYong": "يمكن استخدامه خلال أيام",
    "QSRSJH": "الرجاء إدخال رقم الهاتف",
    "QSRYZM": "الرجاء إدخال رمز التحقق",
    "QSRXMM": "الرجاء إدخال كلمة المرور الجديدة",
    "QSRZQSJGS": "الرجاء إدخال تنسيق هاتف صحيح",
    "ChongZhiMiMa": "إعادة تعيين كلمة المرور",
    "QSRNDSJHM": "الرجاء إدخال رقم هاتفك",
    "QSRDXYZ": "الرجاء إدخال التحقق عبر الرسائل القصيرة",
    "HQYZM": "الحصول على رمز التحقق",
    "HKCXHQ": "يمكن الحصول عليه مرة أخرى بعد",
    "QSR6_20WSZHZ": "الرجاء إدخال كلمة مرور من 6 إلى 20 رقم أو حرف",
// إعدادات المشاركة
    "QSRSPJGBL": "الرجاء إدخال نسبة سعر المنتج",
    "SPJGBLBXDY": "نسبة سعر المنتج يجب أن تكون أكبر من أو تساوي 100، وأقل من 999.99",
    "DPMCZBZCTS": "اسم المتجر暂不支持特殊符号",
    "LXRZBZCTSF": "جهة الاتصال暂不支持特殊符号",
    "LXFSZBZCTS": "طريقة الاتصال暂不支持特殊符号",
    "LXDZZBZCTS": "عنوان الاتصال暂不支持特殊符号",
    "DPJJZBZCTS": "وصف المتجر暂不支持特殊符号",
    "QSRDPJJ_ZD": "الرجاء إدخال وصف المتجر، максимум 50 حرف",
    "FenXiangSheZhi": "إعدادات المشاركة",
    "NDWSCSPJG": "سعر منتجات المتجر المحمول الخاص بك",
    "NDDHJ_": "سعر طلبك ×",
    "LXXX_KBJ_": "معلومات الاتصال (يمكن التعديل)",
    "DianPuMingCheng": "اسم المتجر",
    "JianJie": "الوصف",
    "QSRDPMC": "الرجاء إدخال اسم المتجر",
    "LianXiRen": "جهة الاتصال",
    "QSRLXR": "الرجاء إدخال جهة الاتصال",
    "LianXiFangShi": "طريقة الاتصال",
    "QSRLXFS": "الرجاء إدخال طريقة الاتصال",
    "LianXiDiZhi": "عنوان الاتصال",
    "QSRLXDZ": "الرجاء إدخال عنوان الاتصال",
// المستخدم
    "WoDeDingDan": "طلباتي",
    "ZuiJinLiuLan": "التصفح الأخير",
    "ShouCangShangPin": "منتجات المفضلة",
    "BDYYZH_ZC": "ربط حساب موجود | إنشاء حساب جديد",
    "DL_ZC": "تسجيل الدخول | التسجيل",
    "BangDingShouJi": "ربط الهاتف",
    "TS_BDSJHM_": "ملاحظة: ربط رقم الهاتف يجعل الحساب أكثر أمانًا!",
    "ChaKanQuanBu": "عرض الكل",
    "ShouHuoDiZhi": "عنوان الاستلام",
    "LianXiWoMen": "اتصل بنا",
    "SheZhi": "الإعدادات",
    "QuQianDao": "الذهاب إلى التوقيت",
    "JiFenShangCheng": "متجر النقاط",
    "TuiGuangShangPin": "الترويج للمنتجات",
    "QuChaKan": "الذهاب لعرض",
    "JiFenHuanLi": "تبادل النقاط بالهدايا",
    "DYSPBQ": "طباعة ملصق المنتج",
// حول المستخدم
    "GYYSDH": "حول Yunshang Order",
    "YQHYSMEWM_": "ادعو الأصدقاء لمسح الرمز الشريطي، التنزيل والتنصيب المباشر",
    "DangQianBanBen": "الإصدار الحالي",
// عنوان المستخدم
    "ZWSHDZ": "لا توجد عنوان استلام",
    "WoDeDiZhi": "عناويني",
    "ZhiNengShiBie": "التعرف الذكي",
    "ZTDZXXKZNS": "الصق معلومات العنوان للتعرف الذكي على الاسم والهاتف والعنوان",
    "MoRen": "الافتراضي",
    "QRSCDZ": "هل أنت متأكد من حذف العنوان؟",
    "SHRXM": "اسم المستلم",
    "SJHMHGDDHZ": "يجب إدخال رقم هاتف محمول أو رقم هاتف ثابت على الأقل",
    "QSRSHRXM": "الرجاء إدخال اسم المستلم",
    "ShouJiHaoMa": "رقم الهاتف المحمول",
    "GuDingDianHua": "رقم الهاتف الثابت",
    "QSRGDDH": "الرجاء إدخال رقم الهاتف الثابت",
    "SuoZaiDiQu": "المنطقة",
    "QSRSZDQ": "الرجاء إدخال المنطقة",
    "QSRXXDZ": "الرجاء إدخال العنوان التفصيلي!",
    "QSRZQDSJHM": "الرجاء إدخال رقم هاتف محمول صحيح",
    "QSRZQDGDDH": "الرجاء إدخال رقم هاتف ثابت صحيح",
    "XiangXiDiZhi": "العنوان التفصيلي",
    "MoRenDiZhi": "العنوان الافتراضي",
    "SWMRDZ": "تعيين كعنوان افتراضي",
    "BCBSY": "حفظ واستخدام",
// ربط المستخدم واحد
    "QSRSJHM": "الرجاء إدخال رقم الهاتف",
    "GYHYZC": "هذا المستخدم مسجل بالفعل",
    "GSJHMYJZCG": "هذا رقم الهاتف مسجل بالفعل",
    "QZJDLJK": "الرجاء تسجيل الدخول مباشرة",
    "QuDengLu": "الذهاب إلى تسجيل الدخول",
    "BDHKYTGSJH": "يمكن تسجيل الدخول عبر رقم الهاتف بعد الربط، مما يسهِّل استعادة كلمة المرور وتعزيز أمان الحساب",
    "_BDHKYTGSJ": "*يمكن تسجيل الدخول عبر رقم الهاتف بعد الربط، مما يسهِّل استعادة كلمة المرور وتعزيز أمان الحساب",
    "QSRSJYZM": "الرجاء إدخال رمز التحقق من الهاتف",
    "BDXSJ": "ربط هاتف جديد",
    "DXYZM": "رمز التحقق من الرسائل القصيرة",
    "XiaYiBu": "الخطوة التالية",
    "TGCBZ": "تخطى هذه الخطوة",
// ربط المستخدم اثنين
    "DBDSJHMBCZ": "رقم الهاتف الذي سيتم ربطه غير موجود!",
    "QSRDLMM": "الرجاء إدخال كلمة مرور تسجيل الدخول!",
    "_GSJHMYBDY": "*هذا رقم الهاتف مرتبط بحساب Yunshang Order بالفعل، تحقق من كلمة مرور تسجيل الدخول للهاتف، لربط الحساب الحالي",
    "DQZHMMJTBW": "سيتم مزامنة كلمة مرور الحساب الحالي ككلمة مرور تسجيل الدخول للهاتف",
    "DangQianZhangHao": "الحساب الحالي",
//
    "QDYJZ": "هل أنت متأكد من حذف هذه",
    "JSPSCM": "منتج؟",
    "ShanChuChengGong": "تم الحذف بنجاح!",
// معلومات المستخدم
    "SJGSCW": "تنسيق الهاتف غير صحيح",
    "YXGSCW": "تنسيق البريد الإلكتروني غير صحيح",
    "WoDeZhangHao": "حسابي",
    "YouXiang": "البريد الإلكتروني",
    "ShouJi": "الهاتف",
    "XingMing": "الاسم",
    "XiuGaiTouXiang": "تعديل الصورة الرمزية",
    "JiBenXinXi": "المعلومات الأساسية",
    "ZhangHaoAnQuan": "أمان الحساب",
    "XiuGaiMiMa": "تعديل كلمة المرور",
    "DianJiBangDing": "انقر لربط",
    "RYDSHTY_QL": "إذا فقدته أو توقف استخدامه، الرجاء تغييره على الفور لتجنب سرقة الحساب",
    "WBZNDZHAQ_": "لضمان أمان حسابك، الرجاء ربط الهاتف",
    "QSRNDXM": "الرجاء إدخال اسمك",
    "QSRNDDH": "الرجاء إدخال هاتفك",
    "QSRNDYX": "الرجاء إدخال البريد الإلكتروني",
// إعدادات المستخدم
    "QCHCHXCXDL": "يتطلب إعادة تسجيل الدخول بعد مسح التخزين المؤقت",
    "QingChuHuanCun": "مسح التخزين المؤقت",
    "QDYQCHCM": "هل أنت متأكد من مسح التخزين المؤقت؟",
    "TuiChuDengLu": "تسجيل الخروج",
    "QieHuanZhangHao": "تبديل الحساب",
// المورد المستخدم
    "LianXi": "اتصل",
    "GongSiDianHua": "هاتف الشركة",
    "DiZhi": "العنوان",
// تفاصيل القسائم النقدية
    "DJQMX": "تفاصيل القسيمة النقدية",
// قائمة القسائم النقدية
    "BuKeYong": "غير متوفر",
    "KeYong": "متوفر",
    "ZWDJQ": "لا توجد قسائم نقدية",
    "ZongEDu": "إجمالي الحصة",
    "FaFangShiJian": "وقت التوزيع",
    "EDYYW": "الحصة مستنفذة",
    "QBSPKY": "متوفر لجميع المنتجات",
// قائمة اختيار القسائم النقدية
    "WDDJQ": "قسائم النقدية الخاصة بي",
    "KYDJQ": "قسائم النقدية المتوفرة",
    "DJQKDK": "يمكن لقسيمة النقدية الخصم",
    "CKKYSP": "عرض المنتجات المتوفرة",
    "BKYDJQ": "قسائم النقدية غير المتوفرة",
    "BKYYY_ZWFH": "سبب عدم القدرة على الاستخدام: لا توجد منتجات تفي بالشروط",
// تفاصيل المنتج
    "DQSPWSCGGT": "لم يتم تحميل صورة المواصفات لهذا المنتج، لا يدعم ضبط الأضواء!",
    "BoFangShiPin": "تشغيل الفيديو",
    "Gong1GeGuiGe": "إجمالي {num} مواصف",
    "YiXuanGuiGe": "المواصفات المختارة",
    "XuanGuiGe": "اختيار المواصفات",
    "LingQuan": "الحصول على القسيمة",
    "1ZhongCuXiao": "1 نوع من الترويج",
    "1ZhangKeYong": "1 متوفر",
    "ZuiGaoKeSheng": "أعلى توفير",
    "ShangPinTaoCan": "حزمة المنتج",
    "Gong1GeTaoCan": "إجمالي 1 حزمة",
    "ShangPinCanShu": "معلمات المنتج",
    "ZhanKai": "توسع",
    "YiShouCang": "مُضاف إلى المفضلة",
    "ShouCang": "إضافة إلى المفضلة",
    "KeFu": "الدعم الفني",
    "XiangQing": "التفاصيل",
    "TuiJian": "المرجّح",
    "BianHao": "الرقم التسلسلي",
    "ShangPinXinXi": "معلومات المنتج",
    "KLYHQ": "قسائم الخصم المتوفرة",
    "KuCunBuZu": "المخزن غير كافٍ",
    "DuoGuiGe": "معددة المواصفات",
    "YiShou": "مُباع",
    "SWBHZ_YS": "تحتاج إلى إعادة التخزين، مُباع",
    "CuXiaoShangPin": "منتج مُروج",
// البحث عن المنتج
    "NHWSRSSNR": "أنت لم تُدخل محتوى البحث بعد",
    "SouSuo": "بحث",
    "SSY1XGDSP": "البحث عن منتجات مرتبطة بـ {searchKey}",
    "Yue1GeShangPin": "حوالي {num} منتج",
    "ZuiJinSouSuo": "البحث الأخير",
    "QingChu": "مسح",
    "ZWSSJL": "لا توجد سجلات بحث",
// خاصية المنتج
    "ZGJGBNDYZD": "لا يمكن لأعلى سعر أن يكون أقل من أقل سعر",
    "ShangPinBiaoQian": "علامة المنتج",
    "BuGaoYu1": "لا يزيد عن 1",
    "BuDiYu1": "لا يقل عن 1",
    "FengGe": "النمط",
// قائمة الترويج للمنتجات
    "JiJiangKaiShi": "سيبدأ قريبًا",
    "QuanBuCuXiao": "كل الترويج",
// قائمة حزمة المنتجات
    "Gong1JianShangPin": "إجمالي 1 منتج",
    "Sheng": "توفير",
// تفاصيل حزمة المنتجات
    "GTCZGWCZDS": "لقد وصل عدد الحزم في عربة التسوق إلى الحد الأقصى للشراء، لا يمكن إضافتها إلى عربة التسوق",
    "GTCKCBZ_BK": "مخزن الحزمة غير كافٍ، لا يمكن إضافتها إلى عربة التسوق",
    "JinSheng1Tao": "باقي 1套",
    "XianGou1Tao": "حد الشراء 1套",
    "TaoCanXiangQing": "تفاصيل الحزمة",
    "DanMaiJia": "سعر البيع الفردي",
    "TaoCanJia": "سعر الحزمة",
    "HDYJS": "انتهى الحدث",
// رسالة المنتج
    "WDL_QXDL": "غير مسجل الدخول، الرجاء تسجيل الدخول أولاً",
// علامة قائمة المنتجات
    "XinPinShangShi": "منتج جديد",
    "WDLZH_ZWCX": "لم يتم تسجيل الدخول، لا توجد نشاطات ترويجية!",
    "YiXiaShangPin": "المنتجات التالية",
// قائمة المنتجات
    "1ZhongGuiGe": "1 نوع من المواصفات",
    "YouKuCun": "متوفر في المخزن",
// مرشح المنتجات
    "BuGaoYu": "لا يزيد عن",
    "BuDiYu": "لا يقل عن",
    "CuXiao": "الترويج",
    "ZDYXXZ3G": "يسمح باختيار 3 كحد أقصى",
    "GouMai": "شراء",
    "Gong1Jian": "إجمالي {num} قطعة",
// المنتجات التي تم طلبها
    "DLHCKJG": "عرض السعر بعد تسجيل الدخول",
    "M1JZ1J": "عندما يصل إلى {num} قطعة، تحصل على {presentNum} قطعة مجاناً",
    "CZPF_ZZCXC": "العملية متكررة، جاري المحاولة مرة أخرى",
    "XSZJJXZ": "انخفاض فوري محدود الوقت جاري التنفيذ",
    "YXSPM1YZ1J_": "المنتجات التالية {str}، أضف إلى عربة التسوق وادفع للحصول على الخصم!",
    "TiaoXingMa": "الباركود",
    "XiangGuanTuiJian": "النصائح ذات الصلة",
    "YSSPBKJRGW": "لا يمكن إضافة المنتجات المتوفرة مسبقًا إلى عربة التسوق، تمت إضافة المنتجات غير المتوفرة مسبقًا لك!",
    "YSSPBKLJGM": "لا يمكن شراء المنتجات المتوفرة مسبقًا على الفور، الرجاء إزالة المنتجات المتوفرة مسبقًا ثم إعادة الشراء!",
    "SPSLYW": "عدد المنتجات غير صحيح",
    "ShangPin1QiShou": "منتج {num} من البيع",
    "SPDGSLBNCG": "عدد الطلبات للمنتج لا يمكن أن يتجاوز {num}",
    "QRYCXZSP": "تأكيد إزالة المنتجات المختارة",
    "QRYCSYSXSP": "تأكيد إزالة جميع المنتجات المنتهية",
    "QRYCXZSXSP": "تأكيد إزالة المنتجات المنتهية المختارة",
    "M1YZ1J": "عندما يصل إلى {num} يوان، تحصل على {presentNum} قطعة مجاناً",
    "M1YJ1Y": "عندما يصل إلى {price} يوان، يتم تخفيض {money} يوان",
    "M1J1": "عندما يصل إلى {price}، يتم تخفيض {money}",
    "M1YD1Z": "عندما يصل إلى {price} يوان، يتم تخفيض {money}%",
    "DDM1YHZ": "عندما يصل سعر الطلب إلى {price} يوان، تحصل على",
    "YiHuoZeng": "تم الحصول عليها",
    "ZG1YLXM1YZ1": "اشتري المزيد {price} يوان للحصول على {str}",
    "ZG1JLXM1JZ1": "اشتري المزيد {num} قطعة للحصول على {str}",
    "QCSXSP": "مسح المنتجات المنتهية",
    "YiXuanShangPin": "المنتجات المختارة",
    "QuJieSuan": "الذهاب إلى التسوية",
    "ShiXiaoShangPin": "منتجات منتهية",
    "DingDanGuanLi": "إدارة الطلبات",
    "ZhuangTai": "الحالة",
    "ShangPinChuKu": "منتج الخروج من المخزن",
    "DengDaiShouHuo": "في انتظار الاستلام",
    "PeiSongXinXi": "معلومات التوصيل",
    "FuKuanXinXi": "معلومات الدفع",
    "GDFKJL": "المزيد من سجلات الدفع",
    "WuLiuFuJian": "مرفقات اللوجستية",
    "ZanWuFuJian": "لا توجد مرفقات",
    "YiFa": "مُرسل",
    "YingFuZongE": "إجمالي المبلغ المستحق",
    "FuKuanShiJian": "وقت الدفع",
    "ZhangHuHaoMa": "رقم الحساب",
    "KeYongYuE": "الرصيد المتوفر",
    "TianJiaChengGong": "تمت الإضافة بنجاح",
    "ShanChuDiZhi": "حذف العنوان",
    "QXZSHDZ": "الرجاء اختيار عنوان الاستلام",
    "YiHuoZengPin": "الهدايا التي تم الحصول عليها",
    "YiYouHui1Yuan": "تم التوفير {money} يوان",
    "QWSFPXX": "الرجاء إكمال معلومات الفاتورة",
    "1ZSP": "{num} نوع من المنتجات",
    "Gong": "إجمالي",
    "Jian": "قطعة",
    "ShangPinJinE": "مبلغ المنتج",
    "YunFeiDaoFu": "تكاليف الشحن عند الاستلام",
    "QSRZQDSHRX": "الرجاء إدخال اسم مستلم صحيح",
    "QSRZQDXXDZ": "الرجاء إدخال عنوان تفصيلي صحيح",
    "DBQ_MYZDDY": "آسف، لا يمكن العثور على الصفحة المقابلة",
    "ShouHuoChengGong": "تم الاستلام بنجاح",
    "Hi_HuanYingNin": "مرحبًا بك",
    "YiFaEWuLiu": "تم إرسال e-لوجستية",
    "NinDeDingDan": "طلبك",
    "ZBNBHBQ": "لا يمكن أن يحتوي على تعابير تواصل جسدية",
    "XMBNWK": "الاسم لا يمكن أن يكون فارغًا",
    "XiTongSheZhi": "إعدادات النظام",
    "ZhangHaoXinXi": "معلومات الحساب",
    "QingShuRuXingMing": "الرجاء إدخال الاسم",
    "QWSZL_JZYG": "الرجاء إكمال البيانات، مما سيساعد في تقديم خدمة أفضل لك",
    "QSRZQDYXGS": "الرجاء إدخال تنسيق بريد إلكتروني صحيح",
    "QTXZQDCWXX": "الرجاء ملء المعلومات المالية الصحيحة، لتمكن شريكك من إصدار الفاتورة لك",
    "GXSHDZCG": "تم تحديث عنوان الاستلام بنجاح",
    "BCSHDZCG": "تم حفظ عنوان الاستلام بنجاح",
    "XinZengDiZhi": "إضافة عنوان جديد",
    "QXZYQXSCDS": "الرجاء اختيار المنتجات التي تريد إلغاء تفضيلها",
    "QuXiaoShouCang": "إلغاء التفضيل",
    "XuanZeGuiGe": "اختيار المواصفات",
    "CaiWuGuanLi": "إدارة المالية",
    "DuiZhangMingXi": "تفاصيل التسوية",
    "QSRLWJL_JE": "الرجاء إدخال سجل الاتصال/المبلغ",
    "YiGouMai1Ci": "تم الشراء {count} مرة",
    "6_1GouMai": "{time} شراء",
    "TZGGXQ": "تفاصيل إعلان الإشعار",
    "ZYXSCSP": "يسمح فقط بتحميل الفيديوهات",
    "SCSPDXBYXC": "حجم الفيديو المحمل لا يسمح بتحميل ما يزيد عن {size}",
    "YDHSP": "منتجات الطلب",
    "ShangPinPinPai": "علامة تجارية المنتج",
    "ShangPinLieBiao": "قائمة المنتجات",
    "LingShouJia": "سعر البيع بالتجزئة",
    "YouHuiJia": "سعر الخصم",
    "LiJiGouMai": "الشراء الفوري",
    "ZhuTu": "الصورة الرئيسية",
    "WuXianZhi": "بدون حدود",
    "XiaoJi": "المجموع الجزئي",
    "SCXZSP": "حذف المنتجات المختارة",
    "QSRDDH": "الرجاء إدخال رقم الطلب",
    "QSRDDH_SPMC": "الرجاء إدخال رقم الطلب/اسم المنتج",
    "CaoZuo": "العملية",
    "WuLiuXinXi": "معلومات اللوجستية",
    "CaoZuoLeiXing": "نوع العملية",
    "CaoZuoRiZhi": "سجل العملية",
    "CaoZuoShiJian": "وقت العملية",
    "ZhangHuMingCheng": "اسم الحساب",
    "KaiHuYinHang": "البنك المُفتوح",
    "DDTJCG_XZZC": "تم تقديم الطلب بنجاح، يتبقى خطوة أخيرة",
    "ZhiFuJinE": "مبلغ الدفع",
    "DZFJE": "مبلغ الدفع المستحق",
    "QTXYXSMB": "أدخل بعض التفسيرات",
    "XZSKYHZH": "اختيار حساب البنك القاطع",
    "TiShi": "ملاحظة",
    "NHY1GDDGJ1Y": "لديك {num} طلبات بإجمالي {money} يوان غير مدفوعة",
    "QKJQHCKJXX": "يمكن استكمال الطلب فقط بعد تسوية الدين",
    "HDDDXX": "التحقق من معلومات الطلب",
    "BJSHDZ": "تعديل عنوان الاستلام",
    "TongZhiGongGao": "إعلان الإشعار",
    "YinHangZhangHao": "رقم الحساب البنكي",
    "XiuGaiShouJi": "تعديل الهاتف",
    "LXRXX": "معلومات جهة الاتصال",
    "GSCWXX": "معلومات مالية الشركة",
    "QSRKHYHMCJ": "الرجاء إدخال اسم البنك المُفتوح וש�عبه",
    "QSRYHZH": "الرجاء إدخال رقم الحساب البنكي",
    "PiLiangCaoZuo": "العملية الجماعية",
    "GouMaiJiLu": "سجل الشراء",
    "TongZhiBiaoTi": "عنوان الإشعار",
    "FaBuShiJian": "وقت النشر",
    "XiaoXiLeiXing": "نوع الرسالة",
    "XiaoXiNeiRong": "محتوى الرسالة",
    "JieShouShiJian": "وقت الاستقبال",
    "QuanBuPinPai": "جميع العلامات التجارية",
    "WXSYS_DHGBJ": "مسح رمز ويچات، الطلب أكثر سهولة",
    "GZWXGZH": "متابعة حساب ويچات الرسمي",
    "FuWuReXian": "خط الدعم",
    "SouSuoLiShi": "تاريخ البحث",
    "QuanBuShanChu": "مسح الكل",
    "NH_HYLDYSDH": "مرحبًا بك في {company}!",
    "ZSJDH": "الطلب عبر الهاتف",
    "SYS_GZWXGZH": "مسح، متابعة حساب ويچات الرسمي",
    "GuanZhuWoMen": "متابعتنا",
    "QBSPFL": "جميع فئات المنتجات",
    "QuPeiDeng": "الذهاب إلى ضبط الأضواء",
    "KuanXiang": "المبلغ",
    "QSRSPMC_GG_": "الرجاء إدخال اسم المنتج/المواصفات/الرقم التسلسلي/الحرف الأول",
    "NH_HYLDYSD": "مرحبًا بك في متجر Yunshang Order!",
    "ReXiao": "مُرجَّح",
    "20Tiao_Ye": "20 عنصر/صفحة",
    "ShiChangJia_": "سعر السوق:",
    "_134.10Qi": "Desde S/ 134.10",
    "HJ_BHYF": "المجموع (غير شامل تكاليف الشحن):",
    "QDSCXZSP_": "هل أنت متأكد من حذف المنتجات المختارة؟",
    "QDQCXJSP_": "هل أنت متأكد من مسح المنتجات المسحوبة؟",
    "DDTJCG_XZZ": "تم تقديم الطلب بنجاح، يتبقى خطوة أخيرة!",
    "XuanZeZhangHu": "اختيار الحساب",
    "DaiZhiFu": "لم تتم الدفع بعد",
    "CaiGouDingDan": "طلب المشتريات",
    "DingDanXinXi": "معلومات الطلب",
    "TuiChu": "خروج",
    "KaiHuMingCheng": "اسم البنك المُفتوح",
    "QSRKHMC": "الرجاء إدخال اسم البنك المُفتوح",
    "_QTXZQDCWX": " (الرجاء ملء المعلومات المالية الصحيحة، لتمكن شريكك من إصدار الفاتورة لك)",
    "ShouHuoRen": "المستلم",
    "SWMRSHDZ": "تعيين كعنوان استلام افتراضي",
    "TianJiaDiZhi": "إضافة عنوان",
    "Gong4GeGuiGe": "إجمالي 4 مواصف",
    "Zhi": "فقط",
    "Kuai": "قطعة",
    "Tou": "رأس",
    "Xiang": "علبة",
    "Ping": "علبة",
    "KaiShiRiQi": "تاريخ البدء",
    "JieShuRiQi": "تاريخ الانتهاء",
    "YiXuan": "مُختار",
    "ZhiFuZhuangTai": "حالة الدفع",
    "QDLCKJG": "الرجاء تسجيل الدخول لعرض السعر",
    "YZMBZQ": "رمز التحقق غير صحيح",
    "ZhiFuJiLu": "سجل الدفع",
    "ShangPinMingCheng": "اسم المنتج",
    "DingGouShuLiang": "عدد الطلبات",
    "TuiHuoShuLiang": "عدد الإرجاع",
    "QSRTHNR": "الرجاء إدخال محتوى الإرجاع",
    "SCTHSM": "تحميل وصف الإرجاع",
    "ShenQingShiJian": "وقت التقديم",
    "ShenQingJinE": "مبلغ التقديم",
    "TuiHuoYuanYin": "سبب الإرجاع",
    "TuiHuoShuoMing": "وصف الإرجاع",
    "TuiDanHao": "رقم طلب الإرجاع",
    "SXCZ_XDCG": "الائتمان كافٍ، تم تقديم الطلب بنجاح",
    "SXEDBZ_FKHFH": "حد الائتمان غير كافٍ، الشحن بعد الدفع",
    "CGJKZQ_FKFH": "تجاوز فترة القرض، الشحن بعد الدفع",
    "DDTJCG_XZZCZHYB": "تم تقديم الطلب بنجاح، يتبقى خطوة أخيرة!",
    "QNZ_NWCFK_FZ": "الرجاء إكمال الدفع خلال {time}، وإلا سيتم إلغاء الطلب تلقائيًا.",
    "MianFeiLing": "الحصول على مجاناً",
    "M_KMFLQ_HQ": "يمكن الحصول على مجاناً عندما يصل إلى {target} يوان، يتبقى {short} يوان",
    "YHDMFSP": "المنتجات المجانية التي تم الحصول عليها",
    "JRMFL": "الحصول على مجاناً اليوم",
    "LingGuangLe": "انتهى",
    "KeLingQu": "يمكن الحصول عليه",
    "QSRZFJE": "الرجاء إدخال مبلغ الدفع",
    "QNJKFK_WMJKWNCL": "الرجاء الدفع في أقرب وقت ممكن، سنقوم بمعالجة طلبك بسرعة!",
    "XianXiaTiYanGuan": "معرض التجربة ال офلاين",
    "QingXuanZheSheng": "الرجاء اختيار المقاطعة",
    "QingXuanZheShi": "الرجاء اختيار المدينة",
    "ZhanGuanDiZhi": "عنوان المعرض",
    "YingYeShiJian": "أوقات العمل",
    "ZhanGuanDianHua": "هاتف المعرض",
    "FenXiang": "مشاركة",
    "TiYanGuanJieShao": "وصف معرض التجربة",
    "DPYDY_QSHX": "المتجر مغلق، الرجاء تقديم الطلب لاحقًا",
    "DaYangShiJian": "وقت الإغلاق",
    "IMEI": "رقم التسلسلي",
    "FanKuanYuE": "رصيد الاسترجاع",
    "FanKuanZhiFu": "دفع الاسترجاع",
    "YiShengZhiFu": "دفع ييشنغ",
    "JiongDongShouYinTai": "محل الدفع جينغدونغ",
    "FKYEBZ": "رصيد الاسترجاع غير كافٍ",
    "FanKuanZhangHu": "حساب الاسترجاع",
    "HaiXuZhiFu": "لا يزال يحتاج إلى الدفع {price}",
    "FaPiaoMingXi": "تفاصيل الفاتورة",
    "FaPiaoZhuShou": "مساعد الفاتورة",
    "WoDeFaPiao": "فواتيري",
    "FaPiaoXiangQing": "تفاصيل الفاتورة",
    "KaiPiaoShiJian": "وقت إصدار الفاتورة",
    "DaiKaiFaPiao": "الفواتير التي تنتظر إصدارها",
    "DKFPJE": "مبلغ الفواتير التي تنتظر إصدارها",
    "KaiPiaoJinE": "مبلغ الفاتورة",
    "GuanLianDanHao": "رقم المرتبط",
    "ChuangJianShiJian": "وقت الإنشاء",
    "ZhiFuPingZheng": "مدى الدفع",
    "QSRZQNR": "الرجاء إدخال محتوى صحيح",
    "QSRTDH_SPMC": "الرجاء إدخال رقم طلب الإرجاع/اسم المنتج",
    "ShangPinRuKu": "منتج الدخول إلى المخزن",
    "TuiKuanChuLi": "معالجة الاسترجاع",
    "YuanDingDanHao": "رقم الطلب الأصلي",
    "TuiHuoXinXi": "معلومات الإرجاع",
    "TuiKuanXinXi": "معلومات الاسترجاع",
    "TuiKuanZhuangTai": "حالة الاسترجاع",
    "ZWTKJL": "لا توجد سجلات استرجاع",
    "GDTKJL": "المزيد من سجلات الاسترجاع",
    "DDDKFQRBJQSH": "الطلب ينتظر موافقة خدمة العملاء على العرض الرجاء الانتظار",
    "BNSRDYHDTSZF": "لا يمكن إدخال علامات اقتباس مفردة وغيرها من الرموز الخاصة",
    "THSLBNWK": "عدد الإرجاع لا يمكن أن يكون فارغًا",
    "BZBNBHBQ": "الملاحظات لا يمكن أن تحتوي على تعابير تواصل جسدية",
    "THSLBKDYKTHSL": "عدد الإرجاع أكبر من عدد الإرجاع المسموح به",
    "DDM_YZ_J": "عندما يصل سعر الطلب إلى {target} يوان، تحصل على {number} قطعة مجاناً",
    "M_JZ_J": "عندما يصل إلى {target} قطعة، تحصل على {number} قطعة مجاناً",
    "M_JJZ_Y": "عندما يصل إلى {target} قطعة، ينخفض إلى {money} يوان",
    "YDHJJZ_Y": "سعر الطلب الأصلي ينخفض إلى {price} يوان",
    "M_JD_Z": "عندما يصل إلى {number} قطعة، يتم تخفيض {percent}%",
    "YDHJD_Z": "سعر الطلب الأصلي مع تخفيض {percent}%",
    // دفع Mercado Pago
    "WDSYT": "محل الدفع الخاص بي",
    "ZZSYMPSMJY": "جاري استخدام معاملة مسح Mercado Pago",
    "SKF": "جهة القبض",
    "SYSFK": "مسح لدفع",
    "DDXQ": "تفاصيل الطلب",
    "YUAN": "يوان",
    // قسائم الخصم
    "GXNHQ_Z_Y_": "تهانينا لك على الحصول على {num} {price} يوان {name}",
    "QBLX": "كل الأنواع",
    "QLQZX": "الذهاب إلى مركز القسائم",
    "YLYH": "الخصم الذي تم الحصول عليه",
    "MZTJJKSY": "يمكن الاستخدام عند تحقيق الشروط",
    "GXNHD_Z_YHQ": "تهانينا لك على الحصول على {num} قسائم خصم",
    "G_Y": "إجمالي {price} يوان",
    "XZYHQ": "اختيار القسيمة",
    "PLXD": "الطلب الجماعي",
    "FHJL": "سجل الشحن",
    "DDTJ": "إحصائيات الطلب",
    "DDGL": "إدارة الطلبات",
    "JKWFH": "عرض فقط غير الشحن",
    "DDS": "عدد الطلبات",
    "DGSPS": "عدد المنتجات التي تم طلبها",
    "THSPS": "عدد المنتجات التي تم إرجاعها",
    "YFHSPS": "عدد المنتجات التي تم شحنها",
    "WFHSPS": "عدد المنتجات التي لم تُشحن",
    "YFHSPJE": "مبلغ المنتجات التي تم شحنها",
    "WFHSPJE": "مبلغ المنتجات التي لم تُشحن",
    "WFH": "لم يُشحن",
    "YGJ": "تقدير",
    "GGBM": "رمز المواصف",
    "SLHJ": "إجمالي الكمية",
    "JEHJ": "إجمالي المبلغ",
    "QPLKY": "متوفر لجميع الفئات",
    "KYCXHDDJSY": "يمكن استخدامه مع أنشطة الترويج",
    "BKDKYF": "لا يمكن الخصم من تكاليف الشحن",
    "SYHBYTH": "لا يتم الاسترجاع بعد الاستخدام",
    "TiJi": "حجم",
    "ZhongLiang": "الوزن",
    "ZongTiJi": "إجمالي الحجم",
    "ZongZhongLiang": "إجمالي الوزن",
    "QSRDHDCKDWLDHSJRSJH": "الرجاء إدخال رقم الطلب/رقم الخروج من المخزن/رقم الشحنة/المرسل إليه/رقم الهاتف",
    "CKDH": "رقم الخروج من المخزن",
    "WLDZT": "حالة مستند اللوجستية",
    "WLDH": "رقم الشحنة",
    "SJR": "المرسل إليه",
};
export default ar_SA
